import React from "react";

export const ProfileIconOutlineIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.121 15.804C5.21942 14.6179 7.58958 13.9963 10 14C12.5 14 14.847 14.655 16.879 15.804M13 8C13 8.79565 12.6839 9.55871 12.1213 10.1213C11.5587 10.6839 10.7956 11 10 11C9.20435 11 8.44129 10.6839 7.87868 10.1213C7.31607 9.55871 7 8.79565 7 8C7 7.20435 7.31607 6.44129 7.87868 5.87868C8.44129 5.31607 9.20435 5 10 5C10.7956 5 11.5587 5.31607 12.1213 5.87868C12.6839 6.44129 13 7.20435 13 8ZM19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
        stroke="#9EACDB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ToastieCloseIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.878735 -0.000115871C0.70488 -0.00014829 0.53492 0.0513806 0.390355 0.147954C0.245789 0.244527 0.133112 0.381806 0.0665766 0.542425C4.08008e-05 0.703045 -0.0173648 0.879789 0.0165616 1.0503C0.050488 1.22081 0.134222 1.37743 0.257172 1.50035L16.4994 17.7425C16.6642 17.9074 16.8878 18 17.1209 18C17.3541 18 17.5776 17.9074 17.7425 17.7425C17.9073 17.5777 17.9999 17.3541 17.9999 17.121C17.9999 16.8878 17.9073 16.6643 17.7425 16.4994L1.5003 0.257228C1.41875 0.17551 1.32186 0.110709 1.21519 0.0665456C1.10852 0.0223827 0.994182 -0.000271709 0.878735 -0.000115871Z"
        fill="white"
      />
      <path
        d="M17.1211 -0.000116348C17.0056 -0.000270844 16.8913 0.0223827 16.7846 0.0665455C16.6779 0.110708 16.581 0.17551 16.4995 0.257229L0.257307 16.4994C0.0924584 16.6643 -0.000152588 16.8878 -0.000152588 17.121C-0.000152588 17.3541 0.0924584 17.5777 0.257307 17.7425C0.422156 17.9074 0.645738 18 0.87887 18C1.112 18 1.33558 17.9074 1.50043 17.7425L17.7426 1.50035C17.8656 1.37744 17.9493 1.22081 17.9832 1.0503C18.0172 0.879789 17.9998 0.703045 17.9332 0.542425C17.8667 0.381805 17.754 0.244528 17.6094 0.147953C17.4649 0.0513802 17.2949 -0.000148773 17.1211 -0.000116348Z"
        fill="white"
      />
    </svg>
  );
};

export const NotificationReadButton = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.878735 -0.000115871C0.70488 -0.00014829 0.53492 0.0513806 0.390355 0.147954C0.245789 0.244527 0.133112 0.381806 0.0665766 0.542425C4.08008e-05 0.703045 -0.0173648 0.879789 0.0165616 1.0503C0.050488 1.22081 0.134222 1.37743 0.257172 1.50035L16.4994 17.7425C16.6642 17.9074 16.8878 18 17.1209 18C17.3541 18 17.5776 17.9074 17.7425 17.7425C17.9073 17.5777 17.9999 17.3541 17.9999 17.121C17.9999 16.8878 17.9073 16.6643 17.7425 16.4994L1.5003 0.257228C1.41875 0.17551 1.32186 0.110709 1.21519 0.0665456C1.10852 0.0223827 0.994182 -0.000271709 0.878735 -0.000115871Z"
        fill="black"
      />
      <path
        d="M17.1211 -0.000116348C17.0056 -0.000270844 16.8913 0.0223827 16.7846 0.0665455C16.6779 0.110708 16.581 0.17551 16.4995 0.257229L0.257307 16.4994C0.0924584 16.6643 -0.000152588 16.8878 -0.000152588 17.121C-0.000152588 17.3541 0.0924584 17.5777 0.257307 17.7425C0.422156 17.9074 0.645738 18 0.87887 18C1.112 18 1.33558 17.9074 1.50043 17.7425L17.7426 1.50035C17.8656 1.37744 17.9493 1.22081 17.9832 1.0503C18.0172 0.879789 17.9998 0.703045 17.9332 0.542425C17.8667 0.381805 17.754 0.244528 17.6094 0.147953C17.4649 0.0513802 17.2949 -0.000148773 17.1211 -0.000116348Z"
        fill="black"
      />
    </svg>
  );
};

export const ToastieSuccessIcon = () => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 19L17.1667 22.6667L24.5 15.3333M35.5 19C35.5 21.1668 35.0732 23.3124 34.244 25.3143C33.4148 27.3161 32.1994 29.1351 30.6673 30.6673C29.1351 32.1994 27.3161 33.4148 25.3143 34.244C23.3124 35.0732 21.1668 35.5 19 35.5C16.8332 35.5 14.6876 35.0732 12.6857 34.244C10.6839 33.4148 8.8649 32.1994 7.33274 30.6673C5.80057 29.1351 4.58519 27.3161 3.75599 25.3143C2.92678 23.3124 2.5 21.1668 2.5 19C2.5 14.6239 4.23839 10.4271 7.33274 7.33274C10.4271 4.23839 14.6239 2.5 19 2.5C23.3761 2.5 27.5729 4.23839 30.6673 7.33274C33.7616 10.4271 35.5 14.6239 35.5 19Z"
        stroke="white"
        strokeWidth="3.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ToastieWarningIcon = () => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 11.6667V19V11.6667ZM19 26.3333H19.0183H19ZM35.5 19C35.5 21.1668 35.0732 23.3124 34.244 25.3143C33.4148 27.3161 32.1994 29.1351 30.6673 30.6673C29.1351 32.1994 27.3161 33.4148 25.3143 34.244C23.3124 35.0732 21.1668 35.5 19 35.5C16.8332 35.5 14.6876 35.0732 12.6857 34.244C10.6839 33.4148 8.8649 32.1994 7.33274 30.6673C5.80057 29.1351 4.58519 27.3161 3.75599 25.3143C2.92678 23.3124 2.5 21.1668 2.5 19C2.5 14.6239 4.23839 10.4271 7.33274 7.33274C10.4271 4.23839 14.6239 2.5 19 2.5C23.3761 2.5 27.5729 4.23839 30.6673 7.33274C33.7616 10.4271 35.5 14.6239 35.5 19Z"
        stroke="white"
        strokeWidth="3.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ToastieErrorIcon = () => {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.6854 13.3141L12.8431 24.1564M12.4896 13.1963L23.4497 24.1564M30.1673 30.1668C28.6351 31.699 26.8161 32.9144 24.8143 33.7436C22.8124 34.5728 20.6668 34.9996 18.5 34.9996C16.3332 34.9996 14.1876 34.5728 12.1857 33.7436C10.1839 32.9144 8.3649 31.699 6.83274 30.1668C5.30057 28.6347 4.08519 26.8157 3.25599 24.8138C2.42678 22.812 2 20.6664 2 18.4996C2 16.3328 2.42678 14.1872 3.25599 12.1853C4.08519 10.1834 5.30057 8.36447 6.83274 6.8323C9.92709 3.73795 14.1239 1.99956 18.5 1.99956C22.8761 1.99956 27.0729 3.73795 30.1673 6.8323C33.2616 9.92665 35 14.1235 35 18.4996C35 22.8756 33.2616 27.0725 30.1673 30.1668Z"
        stroke="white"
        strokeWidth="3.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EmailAddressIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 10C14 8.93914 13.5786 7.92172 12.8284 7.17158C12.0783 6.42143 11.0609 6 10 6C8.93914 6 7.92172 6.42143 7.17158 7.17158C6.42143 7.92172 6 8.93914 6 10C6 11.0609 6.42143 12.0783 7.17158 12.8284C7.92172 13.5786 8.93914 14 10 14C11.0609 14 12.0783 13.5786 12.8284 12.8284C13.5786 12.0783 14 11.0609 14 10ZM14 10V11.5C14 12.163 14.2634 12.7989 14.7322 13.2678C15.2011 13.7366 15.837 14 16.5 14C17.163 14 17.7989 13.7366 18.2678 13.2678C18.7366 12.7989 19 12.163 19 11.5V10C19 8.21997 18.4722 6.47991 17.4832 4.99987C16.4943 3.51983 15.0887 2.36628 13.4442 1.68509C11.7996 1.0039 9.99002 0.82567 8.24419 1.17294C6.49836 1.5202 4.89472 2.37737 3.63604 3.63604C2.37737 4.89472 1.5202 6.49836 1.17294 8.24419C0.82567 9.99002 1.0039 11.7996 1.68509 13.4442C2.36628 15.0887 3.51983 16.4943 4.99987 17.4832C6.47991 18.4722 8.21997 19 10 19C11.5802 19.0016 13.1327 18.5862 14.5 17.794"
        stroke="#9EACDB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ContactNumberOutlineIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 1C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V4C1 12.284 7.716 19 16 19H17C17.5304 19 18.0391 18.7893 18.4142 18.4142C18.7893 18.0391 19 17.5304 19 17V13.72C18.9998 13.5102 18.9337 13.3058 18.8109 13.1356C18.6882 12.9655 18.515 12.8383 18.316 12.772L13.823 11.274C13.5947 11.1981 13.3466 11.2071 13.1244 11.2993C12.9021 11.3915 12.7205 11.5607 12.613 11.776L11.483 14.033C9.03429 12.9264 7.07312 10.9649 5.967 8.516L8.224 7.388C8.43925 7.28045 8.60851 7.0989 8.70072 6.87665C8.79293 6.65439 8.8019 6.40634 8.726 6.178L7.228 1.683C7.16148 1.48398 7.03404 1.31093 6.86372 1.18835C6.6934 1.06577 6.48884 0.99988 6.279 1H3Z"
        stroke="#9EACDB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const InputBoxSuccessIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 10L9 12L13 8M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
        stroke="#00DD9A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const InputBoxWarningIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 6V10V6ZM10 14H10.01H10ZM19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
        stroke="#F0B501"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BellIcon = () => {
  return (
    <svg
      width="32"
      height="34"
      viewBox="0 0 32 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 25.3333H11M21 25.3333H29.3334L26.9917 22.9917C26.6772 22.6771 26.4278 22.3037 26.2576 21.8928C26.0875 21.4819 26 21.0414 26 20.5967V15.3333C26.0003 13.2649 25.3593 11.2472 24.1654 9.55815C22.9715 7.86906 21.2833 6.59161 19.3334 5.90167V5.33333C19.3334 4.44928 18.9822 3.60143 18.357 2.97631C17.7319 2.35119 16.8841 2 16 2C15.116 2 14.2681 2.35119 13.643 2.97631C13.0179 3.60143 12.6667 4.44928 12.6667 5.33333V5.90167C8.78335 7.275 6.00002 10.98 6.00002 15.3333V20.5983C6.00002 21.495 5.64335 22.3567 5.00835 22.9917L2.66669 25.3333H11H21ZM21 25.3333V27C21 28.3261 20.4732 29.5979 19.5356 30.5355C18.5979 31.4732 17.3261 32 16 32C14.6739 32 13.4022 31.4732 12.4645 30.5355C11.5268 29.5979 11 28.3261 11 27V25.3333H21Z"
        stroke="#4E66FF"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ArrowLeftIcon = () => {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 6H13M6 11L1 6L6 11ZM1 6L6 1L1 6Z"
        stroke="#252A48"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ArrowRightIcon = () => {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 6H1M8 1L13 6L8 1ZM13 6L8 11L13 6Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ArrowRightIconDashboard = () => {
  return (
    <svg
      width="18"
      height="8"
      viewBox="0 0 18 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.3536 4.35355C17.5488 4.15829 17.5488 3.84171 17.3536 3.64645L14.1716 0.464466C13.9763 0.269204 13.6597 0.269204 13.4645 0.464466C13.2692 0.659728 13.2692 0.976311 13.4645 1.17157L16.2929 4L13.4645 6.82843C13.2692 7.02369 13.2692 7.34027 13.4645 7.53553C13.6597 7.7308 13.9763 7.7308 14.1716 7.53553L17.3536 4.35355ZM0 4.5H17V3.5H0V4.5Z"
        fill="#304FFE"
      />
    </svg>
  );
};
export const ArrowDownIcon = () => {
  return <></>;
};
export const ArrowUpIcon = () => {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 6L6 1M6 1L11 6M6 1V13"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ChevronCardUpIcon = () => {
  return (
    <svg
      width="16"
      height="9"
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 8L8 0.999999L15 8"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ChevronCardDownIcon = () => {
  return (
    <svg
      width="16"
      height="9"
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 1L8 8L1 1"
        stroke="#9EACDB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ChevronCardDownBlackIcon = () => {
  return (
    <svg
      width="16"
      height="9"
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 1L8 8L1 1"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ChevronDownIcon = () => {
  return (
    <svg
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.292787 0.305288C0.480314 0.117817 0.734622 0.0125018 0.999786 0.0125018C1.26495 0.0125018 1.51926 0.117817 1.70679 0.305288L4.99979 3.59829L8.29279 0.305288C8.38503 0.209778 8.49538 0.133596 8.61738 0.0811869C8.73939 0.0287779 8.87061 0.00119157 9.00339 3.77571e-05C9.13616 -0.00111606 9.26784 0.0241854 9.39074 0.0744663C9.51364 0.124747 9.62529 0.199 9.71918 0.292893C9.81307 0.386786 9.88733 0.498438 9.93761 0.621334C9.98789 0.744231 10.0132 0.87591 10.012 1.00869C10.0109 1.14147 9.9833 1.27269 9.93089 1.39469C9.87848 1.5167 9.8023 1.62704 9.70679 1.71929L5.70679 5.71929C5.51926 5.90676 5.26495 6.01207 4.99979 6.01207C4.73462 6.01207 4.48031 5.90676 4.29279 5.71929L0.292787 1.71929C0.105316 1.53176 0 1.27745 0 1.01229C0 0.747124 0.105316 0.492816 0.292787 0.305288Z"
        fill="black"
      />
    </svg>
  );
};
export const LightModeActiveIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0977 0.902256C11.0977 0.403954 11.5017 0 12 0C12.4983 0 12.9023 0.403954 12.9023 0.902256V1.62406C12.9023 2.12236 12.4983 2.52632 12 2.52632C11.5017 2.52632 11.0977 2.12236 11.0977 1.62406V0.902256Z"
        fill="white"
      />
      <path
        d="M11.0977 22.3759C11.0977 21.8776 11.5017 21.4737 12 21.4737C12.4983 21.4737 12.9023 21.8776 12.9023 22.3759V23.0977C12.9023 23.596 12.4983 24 12 24C11.5017 24 11.0977 23.596 11.0977 23.0977V22.3759Z"
        fill="white"
      />
      <path
        d="M19.2093 3.51472C19.5617 3.16237 20.1329 3.16237 20.4853 3.51472C20.8376 3.86708 20.8376 4.43835 20.4853 4.79071L19.9749 5.3011C19.6225 5.65345 19.0513 5.65345 18.6989 5.3011C18.3466 4.94875 18.3466 4.37747 18.6989 4.02512L19.2093 3.51472Z"
        fill="white"
      />
      <path
        d="M4.02511 18.6989C4.37747 18.3466 4.94874 18.3466 5.30109 18.6989C5.65345 19.0513 5.65345 19.6225 5.30109 19.9749L4.7907 20.4853C4.43835 20.8376 3.86707 20.8376 3.51472 20.4853C3.16237 20.1329 3.16237 19.5617 3.51472 19.2093L4.02511 18.6989Z"
        fill="white"
      />
      <path
        d="M23.0977 11.0977C23.596 11.0977 24 11.5017 24 12C24 12.4983 23.596 12.9023 23.0977 12.9023H22.3759C21.8776 12.9023 21.4737 12.4983 21.4737 12C21.4737 11.5017 21.8776 11.0977 22.3759 11.0977H23.0977Z"
        fill="white"
      />
      <path
        d="M1.62406 11.0977C2.12236 11.0977 2.52632 11.5017 2.52632 12C2.52632 12.4983 2.12236 12.9023 1.62406 12.9023H0.902256C0.403954 12.9023 -2.17815e-08 12.4983 0 12C2.17815e-08 11.5017 0.403954 11.0977 0.902256 11.0977H1.62406Z"
        fill="white"
      />
      <path
        d="M20.4853 19.2093C20.8376 19.5617 20.8376 20.1329 20.4853 20.4853C20.1329 20.8376 19.5616 20.8376 19.2093 20.4853L18.6989 19.9749C18.3465 19.6225 18.3465 19.0513 18.6989 18.6989C19.0513 18.3466 19.6225 18.3466 19.9749 18.6989L20.4853 19.2093Z"
        fill="white"
      />
      <path
        d="M5.30109 4.02511C5.65344 4.37746 5.65344 4.94874 5.30109 5.30109C4.94874 5.65345 4.37746 5.65345 4.02511 5.30109L3.51471 4.7907C3.16236 4.43835 3.16236 3.86707 3.51471 3.51472C3.86707 3.16236 4.43834 3.16236 4.7907 3.51472L5.30109 4.02511Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 20.2105C16.5345 20.2105 20.2105 16.5345 20.2105 12C20.2105 7.46545 16.5345 3.78947 12 3.78947C7.46545 3.78947 3.78947 7.46545 3.78947 12C3.78947 16.5345 7.46545 20.2105 12 20.2105ZM12 18.406C15.5379 18.406 18.406 15.5379 18.406 12C18.406 8.46206 15.5379 5.59399 12 5.59399C8.46206 5.59399 5.59399 8.46206 5.59399 12C5.59399 15.5379 8.46206 18.406 12 18.406Z"
        fill="white"
      />
    </svg>
  );
};
export const DarkModeIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 16C12.0554 16 15.4061 12.9824 15.929 9.07012C15.3602 9.55825 14.7044 9.94792 13.988 10.2127C13.0882 12.6468 10.7468 14.382 8 14.382C4.47531 14.382 1.61798 11.5247 1.61798 8C1.61798 5.25324 3.35322 2.91176 5.78728 2.012C6.05208 1.29565 6.44176 0.639827 6.92988 0.070952C3.01758 0.593947 0 3.94458 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="#9EACDB"
      />
      <path
        d="M9.63838 0.167918C9.10952 0.0578509 8.56152 0 8 0C7.63715 0 7.27993 0.0241576 6.92988 0.070952C6.44176 0.639827 6.05208 1.29565 5.78728 2.012C6.47665 1.75717 7.22207 1.61798 8 1.61798C8.00126 1.61798 8.00252 1.61798 8.00378 1.61798C8.4228 1.01287 8.98371 0.513477 9.63838 0.167918Z"
        fill="#9EACDB"
      />
      <path
        d="M5.39326 4.22472C5.39326 7.74941 8.25059 10.6067 11.7753 10.6067C12.5532 10.6067 13.2986 10.4676 13.988 10.2127C14.2428 9.52335 14.382 8.77793 14.382 8C14.382 7.99874 14.382 7.99748 14.382 7.99622C13.6419 8.50873 12.7437 8.80899 11.7753 8.80899C9.24346 8.80899 7.19101 6.75654 7.19101 4.22472C7.19101 3.25633 7.49127 2.35808 8.00378 1.61798L8 1.61798C7.22207 1.61798 6.47665 1.75717 5.78728 2.012C5.53245 2.70136 5.39326 3.44679 5.39326 4.22472Z"
        fill="#9EACDB"
      />
      <path
        d="M13.988 10.2127C14.7044 9.94792 15.3602 9.55825 15.929 9.07012C15.9758 8.72007 16 8.36285 16 8C16 7.43848 15.9421 6.89048 15.8321 6.36162C15.4865 7.01629 14.9871 7.5772 14.382 7.99622L14.382 8C14.382 8.77793 14.2428 9.52335 13.988 10.2127Z"
        fill="#9EACDB"
      />
    </svg>
  );
};
export const VerifiedBadgeIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00083 9.99985L9.00083 11.9999L13.0008 7.99985M5.83583 2.69685C6.55313 2.6396 7.23411 2.35755 7.78183 1.89085C8.40074 1.36312 9.18747 1.07324 10.0008 1.07324C10.8142 1.07324 11.6009 1.36312 12.2198 1.89085C12.7675 2.35755 13.4485 2.6396 14.1658 2.69685C14.9766 2.76135 15.7378 3.11268 16.3129 3.68777C16.888 4.26287 17.2393 5.0241 17.3038 5.83485C17.3611 6.55216 17.6431 7.23313 18.1098 7.78085C18.6376 8.39976 18.9274 9.18649 18.9274 9.99985C18.9274 10.8132 18.6376 11.5999 18.1098 12.2189C17.6431 12.7666 17.3611 13.4475 17.3038 14.1649C17.2393 14.9756 16.888 15.7368 16.3129 16.3119C15.7378 16.887 14.9766 17.2383 14.1658 17.3029C13.4485 17.3601 12.7675 17.6421 12.2198 18.1089C11.6009 18.6366 10.8142 18.9265 10.0008 18.9265C9.18747 18.9265 8.40074 18.6366 7.78183 18.1089C7.23411 17.6421 6.55313 17.3601 5.83583 17.3029C5.02508 17.2383 4.26385 16.887 3.68875 16.3119C3.11365 15.7368 2.76233 14.9756 2.69783 14.1649C2.64058 13.4475 2.35853 12.7666 1.89183 12.2189C1.3641 11.5999 1.07422 10.8132 1.07422 9.99985C1.07422 9.18649 1.3641 8.39976 1.89183 7.78085C2.35853 7.23313 2.64058 6.55216 2.69783 5.83485C2.76233 5.0241 3.11365 4.26287 3.68875 3.68777C4.26385 3.11268 5.02508 2.76135 5.83583 2.69685Z"
        stroke="#9EACDB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const GreenCheckIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 10L9 12L13 8M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
        stroke="#00DD9A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PendingIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 8V13V8ZM13 18H13.0125H13ZM24.25 13C24.25 14.4774 23.959 15.9403 23.3936 17.3052C22.8283 18.6701 21.9996 19.9103 20.955 20.955C19.9103 21.9996 18.6701 22.8283 17.3052 23.3936C15.9403 23.959 14.4774 24.25 13 24.25C11.5226 24.25 10.0597 23.959 8.69481 23.3936C7.3299 22.8283 6.08971 21.9996 5.04505 20.955C4.00039 19.9103 3.17172 18.6701 2.60636 17.3052C2.04099 15.9403 1.75 14.4774 1.75 13C1.75 10.0163 2.93526 7.15483 5.04505 5.04505C7.15483 2.93526 10.0163 1.75 13 1.75C15.9837 1.75 18.8452 2.93526 20.955 5.04505C23.0647 7.15483 24.25 10.0163 24.25 13Z"
        stroke="#F0B501"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const HidePasswordIcon = () => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.411 15.411L20 19M12.875 16.825C12.2569 16.9419 11.6291 17.0005 11 17C6.52203 17 2.73203 14.057 1.45703 10C1.8003 8.9081 2.32902 7.88346 3.02003 6.971L12.875 16.825ZM8.87803 7.879C9.44069 7.31634 10.2038 7.00025 10.9995 7.00025C11.7952 7.00025 12.5584 7.31634 13.121 7.879C13.6837 8.44166 13.9998 9.20478 13.9998 10.0005C13.9998 10.7962 13.6837 11.5593 13.121 12.122L8.87803 7.879ZM8.87803 7.878L13.12 12.12L8.87803 7.878ZM8.88003 7.88L5.59003 4.59L8.88003 7.88ZM13.122 12.122L16.412 15.412L13.122 12.122ZM2.00003 1L5.59003 4.59L2.00003 1ZM5.59003 4.59C7.20239 3.54957 9.08113 2.9974 11 3C15.478 3 19.268 5.943 20.543 10C19.8391 12.2305 18.3774 14.1446 16.411 15.411L5.59003 4.59Z"
        stroke="#9EACDB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ShowPasswordIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12V12Z"
        stroke="#9EACDB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.45703 12C3.73103 7.943 7.52203 5 11.999 5C16.477 5 20.267 7.943 21.541 12C20.267 16.057 16.477 19 11.999 19C7.52203 19 3.73103 16.057 2.45703 12V12Z"
        stroke="#9EACDB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TimerIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 6V10L13 13M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
        stroke="#252A48"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PasswordLockIcon = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 13V15V13ZM3 19H15C15.5304 19 16.0391 18.7893 16.4142 18.4142C16.7893 18.0391 17 17.5304 17 17V11C17 10.4696 16.7893 9.96086 16.4142 9.58579C16.0391 9.21071 15.5304 9 15 9H3C2.46957 9 1.96086 9.21071 1.58579 9.58579C1.21071 9.96086 1 10.4696 1 11V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19ZM13 9V5C13 3.93913 12.5786 2.92172 11.8284 2.17157C11.0783 1.42143 10.0609 1 9 1C7.93913 1 6.92172 1.42143 6.17157 2.17157C5.42143 2.92172 5 3.93913 5 5V9H13Z"
        stroke="#9EACDB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const InvestedAmountIcon = () => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.89024 19H7.96951M12.0488 19H7.96951M7.96951 19V18.0854M7.96951 8.13415V14.8293M7.96951 8.13415C9.85366 8.13415 11.5732 6.56098 11.5732 4.54878C11.5732 2.53659 10.0732 1 7.96951 1C5.86585 1 4.43902 2.68293 4.43902 4.54878C4.43902 6.41463 5.82927 8.13415 7.96951 8.13415ZM7.96951 18.0854V14.8293M7.96951 18.0854L9.83537 16.2195M12.0488 14.0061L9.83537 16.2195M7.96951 14.8293L6.14024 13M3.94512 10.8049L6.14024 13M9.83537 16.2195C9.83537 15.7805 9.83537 15.1585 9.83537 14.5C9.83537 12.561 11.4634 11.0244 13.3293 11.0244C14.0024 11.0244 14.7073 11.0244 14.9756 11.0244C14.9756 11.1951 14.9756 11.7707 14.9756 12.7073C14.9756 15.0122 13.2927 16.2195 11.6829 16.2195C10.3951 16.2195 9.91463 16.2195 9.83537 16.2195ZM6.14024 13C6.14024 12.878 6.14024 12.4 6.14024 11.4634C6.14024 9.30488 4.54878 7.87805 2.71951 7.87805C2.16341 7.87805 1.34146 7.87805 1 7.87805C1 8.20732 1 8.99024 1 9.4878C1 11.7927 2.86585 13 4.18293 13C5.23659 13 5.92683 13 6.14024 13ZM7.10976 5.31707C7.10976 5.97561 7.76829 6.12195 7.96951 6.12195M7.96951 6.12195C8.17073 6.12195 8.90244 6.08537 8.90244 5.31707C8.90244 4.54878 8.2439 4.54878 7.96951 4.54878C7.69512 4.54878 7.10976 4.32927 7.10976 3.78049C7.10976 3.23171 7.54878 2.97561 7.96951 2.97561M7.96951 6.12195V6.56098M7.96951 2.97561C8.39024 2.97561 8.90244 3.23171 8.90244 3.78049M7.96951 2.97561V2.57317"
        stroke="#9EACDB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BitcoinIcon = () => {
  return (
    <svg
      width="11"
      height="18"
      viewBox="0 0 11 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.82576 15.3947L1.82576 4.14464V2.60542L6.77932 2.60542C7.53869 2.60542 8.18621 2.76232 8.72189 3.07613C9.26346 3.38994 9.67552 3.80441 9.95808 4.31954C10.2465 4.82874 10.3907 5.37939 10.3907 5.97149C10.3907 6.66424 10.2141 7.27114 9.86095 7.79219C9.50775 8.31324 9.03094 8.67146 8.43051 8.86685L8.41285 8.43166C9.23108 8.65073 9.86683 9.05336 10.3201 9.63954C10.7734 10.2257 11 10.9244 11 11.7356C11 12.4816 10.8469 13.127 10.5408 13.6717C10.2406 14.2164 9.80503 14.6398 9.23403 14.9418C8.66891 15.2437 7.99784 15.3947 7.22081 15.3947H1.82576ZM3.41514 13.8849H6.9206C7.39153 13.8849 7.81242 13.799 8.18327 13.6273C8.55413 13.4497 8.84551 13.201 9.05743 12.8813C9.27523 12.5615 9.38413 12.1767 9.38413 11.7267C9.38413 11.2944 9.28701 10.9066 9.09275 10.5632C8.90438 10.2198 8.63654 9.94742 8.28923 9.74611C7.94781 9.53888 7.55046 9.43526 7.0972 9.43526H3.41514L3.41514 13.8849ZM3.41514 7.94317H6.76166C7.1384 7.94317 7.47688 7.86324 7.7771 7.70337C8.0832 7.53759 8.32455 7.30667 8.50115 7.01062C8.68363 6.71457 8.77487 6.3682 8.77487 5.97149C8.77487 5.42084 8.58945 4.97085 8.21859 4.62151C7.84774 4.27217 7.36209 4.0975 6.76166 4.0975H3.41514V7.94317Z"
        fill="#9EACDB"
      />
      <path d="M1.82576 4.14464V2.60542H0L0 4.14464H1.82576Z" fill="#9EACDB" />
      <path
        d="M1.82576 15.3947L1.82576 13.8553H0L0 15.3945L1.82576 15.3947Z"
        fill="#9EACDB"
      />
      <path
        d="M4.70927 2.60546V0L3.41514 0V2.60546L4.70927 2.60546Z"
        fill="#9EACDB"
      />
      <path d="M6.76957 2.60546V0L5.47544 0V2.60546H6.76957Z" fill="#9EACDB" />
      <path d="M4.70927 18V15.3945H3.41514V18H4.70927Z" fill="#9EACDB" />
      <path d="M6.76957 18V15.3945H5.47544V18H6.76957Z" fill="#9EACDB" />
    </svg>
  );
};
export const CurrentValueIcon = () => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 5.55649L5.55649 1H10M1 5.55649L10 14.5565M1 5.55649H6.83682M10 14.5565L19 5.55649M10 14.5565L6.83682 5.55649M10 14.5565L13.2008 5.55649M19 5.55649L14.4435 1H10M19 5.55649H13.2008M10 1L6.83682 5.55649M10 1L13.2008 5.55649M6.83682 5.55649H13.2008"
        stroke="#9EACDB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EditPencilIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.232 3.23233L16.768 6.76833L13.232 3.23233ZM14.732 1.73233C15.2009 1.26343 15.8369 1 16.5 1C17.1631 1 17.7991 1.26343 18.268 1.73233C18.7369 2.20123 19.0003 2.8372 19.0003 3.50033C19.0003 4.16346 18.7369 4.79943 18.268 5.26833L4.5 19.0363H1V15.4643L14.732 1.73233V1.73233Z"
        stroke="#4E66FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PortfolioIcon = () => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3708 4.76226C21.4078 4.72357 21.4372 4.67764 21.4572 4.62708C21.4772 4.57653 21.4875 4.52235 21.4875 4.46763C21.4875 4.41291 21.4772 4.35873 21.4572 4.30817C21.4372 4.25762 21.4078 4.21169 21.3708 4.17299C20.4108 3.16389 19.2689 2.36387 18.0111 1.81924C16.7534 1.2746 15.4048 0.996161 14.0434 1.00004C13.9377 1.00004 13.8364 1.04394 13.7616 1.12208C13.6869 1.20022 13.6449 1.3062 13.6449 1.4167V11.8333C13.6449 11.9157 13.6683 11.9963 13.7121 12.0648C13.7559 12.1333 13.8181 12.1867 13.8909 12.2183C13.9638 12.2498 14.0439 12.2581 14.1212 12.242C14.1985 12.2259 14.2695 12.1862 14.3253 12.128L21.3708 4.76226ZM14.442 1.84181C16.7032 1.93351 18.8586 2.86689 20.5196 4.47362L14.442 10.8274V1.84181Z"
        fill="#A6A9B9"
        stroke="#A6A9B9"
        strokeWidth="0.4"
      />
      <path
        d="M11.3624 2.66602C5.64857 2.66602 1 7.52584 1 13.4993C1 19.4728 5.64857 24.3326 11.3624 24.3326C11.4681 24.3326 11.5694 24.2887 11.6442 24.2105C11.7189 24.1324 11.7609 24.0264 11.7609 23.9159V3.08268C11.7609 2.97217 11.7189 2.86619 11.6442 2.78805C11.5694 2.70991 11.4681 2.66602 11.3624 2.66602ZM10.9638 23.4907C5.8737 23.2713 1.7971 18.8737 1.7971 13.4993C1.7971 8.12495 5.8737 3.72726 10.9638 3.50789V23.4907Z"
        fill="#A6A9B9"
        stroke="#A6A9B9"
        strokeWidth="0.4"
      />
      <path
        d="M22.9649 5.83884C22.9279 5.80015 22.884 5.76946 22.8356 5.74852C22.7873 5.72758 22.7354 5.7168 22.6831 5.7168C22.6308 5.7168 22.5789 5.72758 22.5306 5.74852C22.4822 5.76946 22.4383 5.80015 22.4013 5.83884L15.3558 13.2045C15.3 13.2628 15.2621 13.3371 15.2467 13.4179C15.2313 13.4987 15.2392 13.5825 15.2694 13.6586C15.2995 13.7348 15.3506 13.7998 15.4161 13.8456C15.4817 13.8914 15.5588 13.9158 15.6376 13.9158H25.6014C25.7071 13.9158 25.8085 13.8719 25.8832 13.7938C25.958 13.7157 25.9999 13.6097 25.9999 13.4992C26.0037 12.076 25.7373 10.6661 25.2164 9.3512C24.6954 8.0363 23.9302 6.84248 22.9649 5.83884ZM16.5997 13.0825L22.6774 6.72873C24.2142 8.46515 25.1071 10.7185 25.1948 13.0825H16.5997Z"
        fill="#A6A9B9"
        stroke="#A6A9B9"
        strokeWidth="0.4"
      />
      <path
        d="M24.4059 14.75H14.4421C14.3364 14.75 14.2351 14.7939 14.1603 14.872C14.0856 14.9502 14.0436 15.0562 14.0436 15.1667V25.5833C14.0436 25.6938 14.0856 25.7998 14.1603 25.8779C14.2351 25.9561 14.3364 26 14.4421 26C20.1559 26 24.8045 21.1401 24.8045 15.1667C24.8045 15.0562 24.7625 14.9502 24.6878 14.872C24.613 14.7939 24.5116 14.75 24.4059 14.75ZM14.8407 25.1581V15.5833H23.9992C23.7948 20.7665 19.7985 24.9444 14.8407 25.1581Z"
        fill="#A6A9B9"
        stroke="#A6A9B9"
        strokeWidth="0.4"
      />
    </svg>
  );
};
export const PortfolioActiveIcon = () => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3709 4.76226C21.4079 4.72357 21.4373 4.67764 21.4573 4.62708C21.4773 4.57653 21.4876 4.52235 21.4876 4.46763C21.4876 4.41291 21.4773 4.35873 21.4573 4.30817C21.4373 4.25762 21.4079 4.21169 21.3709 4.17299C20.4109 3.16389 19.269 2.36387 18.0112 1.81924C16.7535 1.2746 15.4049 0.996161 14.0436 1.00004C13.9379 1.00004 13.8365 1.04394 13.7618 1.12208C13.687 1.20022 13.645 1.3062 13.645 1.4167V11.8333C13.645 11.9157 13.6684 11.9963 13.7122 12.0648C13.756 12.1333 13.8182 12.1867 13.8911 12.2183C13.9639 12.2498 14.044 12.2581 14.1213 12.242C14.1986 12.2259 14.2697 12.1862 14.3254 12.128L21.3709 4.76226ZM14.4421 1.84181C16.7033 1.93351 18.8588 2.86689 20.5197 4.47362L14.4421 10.8274V1.84181Z"
        fill="#4762F0"
        stroke="#4762F0"
        strokeWidth="0.4"
      />
      <path
        d="M11.3624 2.66602C5.64857 2.66602 1 7.52584 1 13.4993C1 19.4728 5.64857 24.3326 11.3624 24.3326C11.4681 24.3326 11.5694 24.2887 11.6442 24.2105C11.7189 24.1324 11.7609 24.0264 11.7609 23.9159V3.08268C11.7609 2.97217 11.7189 2.86619 11.6442 2.78805C11.5694 2.70991 11.4681 2.66602 11.3624 2.66602ZM10.9638 23.4907C5.8737 23.2713 1.7971 18.8737 1.7971 13.4993C1.7971 8.12495 5.8737 3.72726 10.9638 3.50789V23.4907Z"
        fill="#4762F0"
        stroke="#4762F0"
        strokeWidth="0.4"
      />
      <path
        d="M22.9649 5.83884C22.9279 5.80015 22.884 5.76946 22.8356 5.74852C22.7873 5.72758 22.7354 5.7168 22.6831 5.7168C22.6308 5.7168 22.5789 5.72758 22.5306 5.74852C22.4822 5.76946 22.4383 5.80015 22.4013 5.83884L15.3558 13.2045C15.3 13.2628 15.2621 13.3371 15.2467 13.4179C15.2313 13.4987 15.2392 13.5825 15.2694 13.6586C15.2995 13.7348 15.3506 13.7998 15.4161 13.8456C15.4817 13.8914 15.5588 13.9158 15.6376 13.9158H25.6014C25.7071 13.9158 25.8085 13.8719 25.8832 13.7938C25.958 13.7157 25.9999 13.6097 25.9999 13.4992C26.0037 12.076 25.7373 10.6661 25.2164 9.3512C24.6954 8.0363 23.9302 6.84248 22.9649 5.83884ZM16.5997 13.0825L22.6774 6.72873C24.2142 8.46515 25.1071 10.7185 25.1948 13.0825H16.5997Z"
        fill="#4762F0"
        stroke="#4762F0"
        strokeWidth="0.4"
      />
      <path
        d="M24.4058 14.75H14.442C14.3363 14.75 14.2349 14.7939 14.1602 14.872C14.0854 14.9502 14.0435 15.0562 14.0435 15.1667V25.5833C14.0435 25.6938 14.0854 25.7998 14.1602 25.8779C14.2349 25.9561 14.3363 26 14.442 26C20.1558 26 24.8044 21.1401 24.8044 15.1667C24.8044 15.0562 24.7624 14.9502 24.6876 14.872C24.6129 14.7939 24.5115 14.75 24.4058 14.75ZM14.8406 25.1581V15.5833H23.9991C23.7947 20.7665 19.7984 24.9444 14.8406 25.1581Z"
        fill="#4762F0"
        stroke="#4762F0"
        strokeWidth="0.4"
      />
    </svg>
  );
};

export const DashboardIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.24 2H5.34C3.15 2 2 3.15 2 5.33V7.23C2 9.41 3.15 10.56 5.33 10.56H7.23C9.41 10.56 10.56 9.41 10.56 7.23V5.33C10.57 3.15 9.42 2 7.24 2Z"
        stroke="#A6A9B9"
        strokeWidth="1.5"
      />
      <path
        d="M18.67 2H16.77C14.59 2 13.44 3.15 13.44 5.33V7.23C13.44 9.41 14.59 10.56 16.77 10.56H18.67C20.85 10.56 22 9.41 22 7.23V5.33C22 3.15 20.85 2 18.67 2Z"
        stroke="#A6A9B9"
        strokeWidth="1.5"
      />
      <path
        d="M18.67 13.4297H16.77C14.59 13.4297 13.44 14.5797 13.44 16.7597V18.6597C13.44 20.8397 14.59 21.9897 16.77 21.9897H18.67C20.85 21.9897 22 20.8397 22 18.6597V16.7597C22 14.5797 20.85 13.4297 18.67 13.4297Z"
        stroke="#A6A9B9"
        strokeWidth="1.5"
      />
      <path
        d="M7.24 13.4297H5.34C3.15 13.4297 2 14.5797 2 16.7597V18.6597C2 20.8497 3.15 21.9997 5.33 21.9997H7.23C9.41 21.9997 10.56 20.8497 10.56 18.6697V16.7697C10.57 14.5797 9.42 13.4297 7.24 13.4297Z"
        stroke="#A6A9B9"
        strokeWidth="1.5"
      />
    </svg>
  );
};
export const DashboardActiveIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.24 2H5.34C3.15 2 2 3.15 2 5.33V7.23C2 9.41 3.15 10.56 5.33 10.56H7.23C9.41 10.56 10.56 9.41 10.56 7.23V5.33C10.57 3.15 9.42 2 7.24 2Z"
        fill="#4762F0"
      />
      <path
        d="M18.6699 2H16.7699C14.5899 2 13.4399 3.15 13.4399 5.33V7.23C13.4399 9.41 14.5899 10.56 16.7699 10.56H18.6699C20.8499 10.56 21.9999 9.41 21.9999 7.23V5.33C21.9999 3.15 20.8499 2 18.6699 2Z"
        fill="#4762F0"
      />
      <path
        d="M18.6699 13.4301H16.7699C14.5899 13.4301 13.4399 14.5801 13.4399 16.7601V18.6601C13.4399 20.8401 14.5899 21.9901 16.7699 21.9901H18.6699C20.8499 21.9901 21.9999 20.8401 21.9999 18.6601V16.7601C21.9999 14.5801 20.8499 13.4301 18.6699 13.4301Z"
        fill="#4762F0"
      />
      <path
        d="M7.24 13.4301H5.34C3.15 13.4301 2 14.5801 2 16.7601V18.6601C2 20.8501 3.15 22.0001 5.33 22.0001H7.23C9.41 22.0001 10.56 20.8501 10.56 18.6701V16.7701C10.57 14.5801 9.42 13.4301 7.24 13.4301Z"
        fill="#4762F0"
      />
    </svg>
  );
};
export const DiscoverIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke="#A6A9B9"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12.8801V11.1201C2 10.0801 2.85 9.22006 3.9 9.22006C5.71 9.22006 6.45 7.94006 5.54 6.37006C5.02 5.47006 5.33 4.30006 6.24 3.78006L7.97 2.79006C8.76 2.32006 9.78 2.60006 10.25 3.39006L10.36 3.58006C11.26 5.15006 12.74 5.15006 13.65 3.58006L13.76 3.39006C14.23 2.60006 15.25 2.32006 16.04 2.79006L17.77 3.78006C18.68 4.30006 18.99 5.47006 18.47 6.37006C17.56 7.94006 18.3 9.22006 20.11 9.22006C21.15 9.22006 22.01 10.0701 22.01 11.1201V12.8801C22.01 13.9201 21.16 14.7801 20.11 14.7801C18.3 14.7801 17.56 16.0601 18.47 17.6301C18.99 18.5401 18.68 19.7001 17.77 20.2201L16.04 21.2101C15.25 21.6801 14.23 21.4001 13.76 20.6101L13.65 20.4201C12.75 18.8501 11.27 18.8501 10.36 20.4201L10.25 20.6101C9.78 21.4001 8.76 21.6801 7.97 21.2101L6.24 20.2201C5.33 19.7001 5.02 18.5301 5.54 17.6301C6.45 16.0601 5.71 14.7801 3.9 14.7801C2.85 14.7801 2 13.9201 2 12.8801Z"
        stroke="#A6A9B9"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const WalletIcon = () => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 14.4163H15.5C16.2293 14.4163 16.9288 14.1266 17.4445 13.6109C17.9603 13.0952 18.25 12.3957 18.25 11.6663V4.33301C18.25 3.60366 17.9603 2.90419 17.4445 2.38846C16.9288 1.87274 16.2293 1.58301 15.5 1.58301H4.5C3.77065 1.58301 3.07118 1.87274 2.55546 2.38846C2.03973 2.90419 1.75 3.60366 1.75 4.33301V11.6663C1.75 12.3957 2.03973 13.0952 2.55546 13.6109C3.07118 14.1266 3.77065 14.4163 4.5 14.4163Z"
        stroke="#9EACDB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CurrentReturnsIcon = () => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.96094 7.93167C4.90451 7.93167 2.42678 10.4094 2.42678 13.4658C2.42678 16.5223 4.90451 19 7.96094 19C11.0174 19 13.4951 16.5223 13.4951 13.4658C13.4951 10.4094 11.0174 7.93167 7.96094 7.93167ZM7.96094 7.93167V5.03485M7.96094 4.17017C8.3933 2.48398 10.5118 -0.360931 15.5272 1.74897C14.0139 5.55368 10.6848 5.85639 7.96094 4.17017ZM7.96094 4.17017V5.03485M7.96094 5.03485C7.91771 3.53601 6.46499 0.797755 1 1.83541C2.12413 5.72662 5.28033 6.28868 7.96094 5.03485ZM9.21478 11.3473C8.95953 11.3473 8.42057 11.3473 7.91771 11.3473M6.5774 15.4979C6.86684 15.4979 7.4306 15.4979 7.91771 15.4979M7.91771 15.4979C8.10973 15.4979 8.28984 15.4979 8.43653 15.4979C9.08507 15.4979 9.34448 15.0655 9.34448 14.5035C9.34448 13.9414 9.21478 13.4658 8.52301 13.4658C8.04741 13.4658 7.788 13.4658 7.48535 13.4658C6.70711 13.4658 6.5774 12.947 6.5774 12.4281C6.5774 11.9093 6.75034 11.3473 7.48535 11.3473C7.62057 11.3473 7.76753 11.3473 7.91771 11.3473M7.91771 15.4979V16.622M7.91771 11.3473V10.2231"
        stroke="#9EACDB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const HomeIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.27136 17H6.92504V12.4663C6.92504 11.099 7.74063 10.3313 8.89205 10.3313C10.0435 10.3313 10.8111 11.2909 10.8111 12.4663V17H15.2729C16.1364 17 16.5922 16.4723 16.5922 15.6087V7.88456C16.5922 7.06897 16.3043 6.61319 15.5127 6.03748C14.8795 5.57691 10.6272 2.48726 8.58021 1C6.65317 2.46327 2.63118 5.51934 1.95952 6.03748C1.11994 6.68516 1 7.21289 1 7.88456V15.6087C1 16.5442 1.57571 17 2.27136 17Z"
        stroke="#4E66FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SearchIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 19L13 13L19 19ZM15 8C15 8.91925 14.8189 9.82951 14.4672 10.6788C14.1154 11.5281 13.5998 12.2997 12.9497 12.9497C12.2997 13.5998 11.5281 14.1154 10.6788 14.4672C9.82951 14.8189 8.91925 15 8 15C7.08075 15 6.1705 14.8189 5.32122 14.4672C4.47194 14.1154 3.70026 13.5998 3.05025 12.9497C2.40024 12.2997 1.88463 11.5281 1.53284 10.6788C1.18106 9.82951 1 8.91925 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8Z"
        stroke="#9EACDB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const InvestIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5833 8.24967V6.41634C15.5833 5.93011 15.3902 5.4638 15.0464 5.11998C14.7025 4.77616 14.2362 4.58301 13.75 4.58301H4.58333C4.0971 4.58301 3.63079 4.77616 3.28697 5.11998C2.94315 5.4638 2.75 5.93011 2.75 6.41634V11.9163C2.75 12.4026 2.94315 12.8689 3.28697 13.2127C3.63079 13.5565 4.0971 13.7497 4.58333 13.7497H6.41667M8.25 17.4163H17.4167C17.9029 17.4163 18.3692 17.2232 18.713 16.8794C19.0568 16.5356 19.25 16.0692 19.25 15.583V10.083C19.25 9.59678 19.0568 9.13046 18.713 8.78665C18.3692 8.44283 17.9029 8.24967 17.4167 8.24967H8.25C7.76377 8.24967 7.29745 8.44283 6.95364 8.78665C6.60982 9.13046 6.41667 9.59678 6.41667 10.083V15.583C6.41667 16.0692 6.60982 16.5356 6.95364 16.8794C7.29745 17.2232 7.76377 17.4163 8.25 17.4163Z"
        stroke="#252A48"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1297 14.1297C14.4735 13.7859 14.6667 13.3196 14.6667 12.8333C14.6667 12.3471 14.4735 11.8808 14.1297 11.537C13.7859 11.1932 13.3196 11 12.8333 11C12.3471 11 11.8808 11.1932 11.537 11.537C11.1932 11.8808 11 12.3471 11 12.8333C11 13.3196 11.1932 13.7859 11.537 14.1297C11.8808 14.4735 12.3471 14.6667 12.8333 14.6667C13.3196 14.6667 13.7859 14.4735 14.1297 14.1297Z"
        stroke="#252A48"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NavbarInvestIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_649_316)">
        <path
          d="M12.3608 8.40439C11.7446 8.36685 11.6062 7.9728 11.5925 7.92798L11.5916 7.92822C11.553 7.76694 11.4083 7.64687 11.2351 7.64687C11.0325 7.64687 10.8682 7.81118 10.8682 8.01382C10.8682 8.05342 10.8746 8.0915 10.8862 8.12725C10.9078 8.20366 11.1361 8.92666 12.0445 9.10254V9.59072C12.0445 9.79341 12.2088 9.95767 12.4114 9.95767C12.6141 9.95767 12.7784 9.79341 12.7784 9.59072V9.11353C13.1296 9.05239 13.3655 8.89888 13.513 8.76006C13.7875 8.50176 13.9514 8.11133 13.9514 7.71563C13.9514 7.3438 13.8056 6.46294 12.4548 6.31392C12.1873 6.28438 11.9964 6.19927 11.8875 6.06084C11.7913 5.93862 11.7809 5.80361 11.7809 5.75127C11.7809 5.68672 11.7986 5.12075 12.4114 5.12075C12.8154 5.12075 12.9773 5.37871 13.0067 5.43267C13.0622 5.56494 13.1928 5.65791 13.3452 5.65791C13.5479 5.65791 13.7122 5.49365 13.7122 5.29097C13.7122 5.23228 13.698 5.177 13.6735 5.12778L13.6745 5.12734C13.571 4.90254 13.2791 4.55088 12.7784 4.42979V3.93726C12.7784 3.73457 12.6141 3.57031 12.4114 3.57031C12.2088 3.57031 12.0445 3.73457 12.0445 3.93726V4.42822C11.3203 4.6002 11.047 5.27593 11.047 5.75122C11.047 6.27969 11.3946 6.93516 12.3743 7.04336C13.2175 7.13638 13.2175 7.57236 13.2175 7.71563C13.2175 7.86782 13.163 8.08174 13.0101 8.22563C12.8656 8.36172 12.6472 8.42202 12.3608 8.40439Z"
          fill="#A6A9B9"
          stroke="#A6A9B9"
          strokeWidth="0.2"
        />
        <path
          d="M16.8467 22.2326C15.4838 20.8714 14.1471 20.1229 12.8672 20.0021V18.2138C12.9268 18.2156 12.9917 18.2167 13.0618 18.2167C13.7956 18.2167 15.0637 18.0951 15.8935 17.3436C17.1148 16.2374 16.8538 14.2775 16.842 14.1946C16.8187 14.0293 16.6867 13.9006 16.5209 13.8814C16.4314 13.8711 14.3132 13.6397 13.1125 14.7271C13.0226 14.8085 12.9417 14.895 12.8672 14.9845V13.3397C14.2809 13.2614 15.6436 12.7333 16.7389 11.832C16.8953 11.7033 16.9178 11.472 16.7891 11.3156C16.6604 11.1591 16.4291 11.1366 16.2726 11.2654C15.2269 12.1259 13.9071 12.6041 12.5512 12.6159C12.5345 12.6135 12.5176 12.6119 12.5003 12.6119C12.4832 12.6119 12.4665 12.6135 12.45 12.6158C9.19707 12.5886 6.55903 9.93433 6.55903 6.6751C6.55903 3.39907 9.22427 0.733838 12.5003 0.733838C15.7763 0.733838 18.4416 3.39907 18.4416 6.6751C18.4416 7.98603 18.0232 9.22881 17.2317 10.2691C17.109 10.4304 17.1402 10.6606 17.3015 10.7833C17.4628 10.906 17.693 10.8748 17.8157 10.7134C18.7053 9.54434 19.1754 8.1479 19.1754 6.6751C19.1754 2.99443 16.181 0 12.5003 0C8.81963 0 5.8252 2.99443 5.8252 6.6751C5.8252 10.2327 8.6227 13.1489 12.1334 13.34V14.9846C12.0589 14.895 11.9779 14.8086 11.8881 14.7271C10.6874 13.6396 8.56919 13.871 8.47969 13.8814C8.31392 13.9006 8.18193 14.0293 8.15859 14.1946C8.14688 14.2775 7.88579 16.2375 9.10718 17.3436C9.93706 18.0952 11.2051 18.2168 11.9388 18.2167C12.009 18.2167 12.0739 18.2156 12.1334 18.2138V20.0026C11.1906 20.0929 10.2079 20.528 9.20659 21.3007C9.04619 21.4246 9.0165 21.6549 9.14028 21.8154C9.26411 21.9759 9.49453 22.0055 9.65498 21.8817C10.6554 21.1096 11.6126 20.7181 12.5002 20.7181C14.7139 20.7181 16.788 23.1391 17.6334 24.2661H7.36582C7.65068 23.8854 8.07544 23.3574 8.5977 22.8268C8.73984 22.6823 8.73799 22.45 8.59355 22.3079C8.44912 22.1657 8.2168 22.1676 8.07466 22.312C7.03203 23.3714 6.37607 24.3927 6.34868 24.4356C6.27656 24.5486 6.27183 24.6919 6.33623 24.8094C6.40063 24.9269 6.52397 25 6.65796 25H18.3422C18.4763 25 18.5996 24.9269 18.664 24.8094C18.7284 24.6919 18.7237 24.5486 18.6516 24.4356C18.6228 24.3906 17.9344 23.3188 16.8467 22.2326ZM13.6052 15.271C14.3262 14.618 15.5671 14.5738 16.136 14.5919C16.1519 15.107 16.0917 16.1739 15.4008 16.7997C14.6797 17.4528 13.4386 17.497 12.87 17.4788C12.8542 16.9638 12.9143 15.8968 13.6052 15.271ZM12.1306 17.4788C11.5617 17.497 10.3207 17.4526 9.59971 16.7997C8.90874 16.1739 8.84868 15.1067 8.8645 14.592C9.43359 14.5739 10.6745 14.6181 11.3954 15.2711C12.0864 15.8969 12.1464 16.9641 12.1306 17.4788Z"
          fill="#A6A9B9"
          stroke="#A6A9B9"
          strokeWidth="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_649_316">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const NavbarActiveInvestIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_534_1044)">
        <path
          d="M12.3608 8.40439C11.7446 8.36685 11.6062 7.9728 11.5925 7.92798L11.5916 7.92822C11.553 7.76694 11.4083 7.64687 11.2351 7.64687C11.0325 7.64687 10.8682 7.81118 10.8682 8.01382C10.8682 8.05342 10.8746 8.0915 10.8862 8.12725C10.9078 8.20366 11.1361 8.92666 12.0445 9.10254V9.59072C12.0445 9.79341 12.2088 9.95767 12.4114 9.95767C12.6141 9.95767 12.7784 9.79341 12.7784 9.59072V9.11353C13.1296 9.05239 13.3655 8.89888 13.513 8.76006C13.7875 8.50176 13.9514 8.11133 13.9514 7.71563C13.9514 7.3438 13.8056 6.46294 12.4548 6.31392C12.1873 6.28438 11.9964 6.19927 11.8875 6.06084C11.7913 5.93862 11.7809 5.80361 11.7809 5.75127C11.7809 5.68672 11.7986 5.12075 12.4114 5.12075C12.8154 5.12075 12.9773 5.37871 13.0067 5.43267C13.0622 5.56494 13.1928 5.65791 13.3452 5.65791C13.5479 5.65791 13.7122 5.49365 13.7122 5.29097C13.7122 5.23228 13.698 5.177 13.6735 5.12778L13.6745 5.12734C13.571 4.90254 13.2791 4.55088 12.7784 4.42979V3.93726C12.7784 3.73457 12.6141 3.57031 12.4114 3.57031C12.2088 3.57031 12.0445 3.73457 12.0445 3.93726V4.42822C11.3203 4.6002 11.047 5.27593 11.047 5.75122C11.047 6.27969 11.3946 6.93516 12.3743 7.04336C13.2175 7.13638 13.2175 7.57236 13.2175 7.71563C13.2175 7.86782 13.163 8.08174 13.0101 8.22563C12.8656 8.36172 12.6472 8.42202 12.3608 8.40439Z"
          fill="#4762F0"
          stroke="#4762F0"
          strokeWidth="0.2"
        />
        <path
          d="M16.8467 22.2326C15.4838 20.8714 14.1471 20.1229 12.8672 20.0021V18.2138C12.9268 18.2156 12.9917 18.2167 13.0618 18.2167C13.7956 18.2167 15.0637 18.0951 15.8935 17.3436C17.1148 16.2374 16.8538 14.2775 16.842 14.1946C16.8187 14.0293 16.6867 13.9006 16.5209 13.8814C16.4314 13.8711 14.3132 13.6397 13.1125 14.7271C13.0226 14.8085 12.9417 14.895 12.8672 14.9845V13.3397C14.2809 13.2614 15.6436 12.7333 16.7389 11.832C16.8953 11.7033 16.9178 11.472 16.7891 11.3156C16.6604 11.1591 16.4291 11.1366 16.2726 11.2654C15.2269 12.1259 13.9071 12.6041 12.5512 12.6159C12.5345 12.6135 12.5176 12.6119 12.5003 12.6119C12.4832 12.6119 12.4665 12.6135 12.45 12.6158C9.19707 12.5886 6.55903 9.93433 6.55903 6.6751C6.55903 3.39907 9.22427 0.733838 12.5003 0.733838C15.7763 0.733838 18.4416 3.39907 18.4416 6.6751C18.4416 7.98603 18.0232 9.22881 17.2317 10.2691C17.109 10.4304 17.1402 10.6606 17.3015 10.7833C17.4628 10.906 17.693 10.8748 17.8157 10.7134C18.7053 9.54434 19.1754 8.1479 19.1754 6.6751C19.1754 2.99443 16.181 0 12.5003 0C8.81963 0 5.8252 2.99443 5.8252 6.6751C5.8252 10.2327 8.6227 13.1489 12.1334 13.34V14.9846C12.0589 14.895 11.9779 14.8086 11.8881 14.7271C10.6874 13.6396 8.56919 13.871 8.47969 13.8814C8.31392 13.9006 8.18193 14.0293 8.15859 14.1946C8.14688 14.2775 7.88579 16.2375 9.10718 17.3436C9.93706 18.0952 11.2051 18.2168 11.9388 18.2167C12.009 18.2167 12.0739 18.2156 12.1334 18.2138V20.0026C11.1906 20.0929 10.2079 20.528 9.20659 21.3007C9.04619 21.4246 9.0165 21.6549 9.14028 21.8154C9.26411 21.9759 9.49453 22.0055 9.65498 21.8817C10.6554 21.1096 11.6126 20.7181 12.5002 20.7181C14.7139 20.7181 16.788 23.1391 17.6334 24.2661H7.36582C7.65068 23.8854 8.07544 23.3574 8.5977 22.8268C8.73984 22.6823 8.73799 22.45 8.59355 22.3079C8.44912 22.1657 8.2168 22.1676 8.07466 22.312C7.03203 23.3714 6.37607 24.3927 6.34868 24.4356C6.27656 24.5486 6.27183 24.6919 6.33623 24.8094C6.40063 24.9269 6.52397 25 6.65796 25H18.3422C18.4763 25 18.5996 24.9269 18.664 24.8094C18.7284 24.6919 18.7237 24.5486 18.6516 24.4356C18.6228 24.3906 17.9344 23.3188 16.8467 22.2326ZM13.6052 15.271C14.3262 14.618 15.5671 14.5738 16.136 14.5919C16.1519 15.107 16.0917 16.1739 15.4008 16.7997C14.6797 17.4528 13.4386 17.497 12.87 17.4788C12.8542 16.9638 12.9143 15.8968 13.6052 15.271ZM12.1306 17.4788C11.5617 17.497 10.3207 17.4526 9.59971 16.7997C8.90874 16.1739 8.84868 15.1067 8.8645 14.592C9.43359 14.5739 10.6745 14.6181 11.3954 15.2711C12.0864 15.8969 12.1464 16.9641 12.1306 17.4788Z"
          fill="#4762F0"
          stroke="#4762F0"
          strokeWidth="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_534_1044">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const NavbarActiveWalletIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 9H7"
        stroke="#4762F0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 10.9692V13.0292C22 13.5792 21.56 14.0292 21 14.0492H19.04C17.96 14.0492 16.97 13.2592 16.88 12.1792C16.82 11.5492 17.06 10.9592 17.48 10.5492C17.85 10.1692 18.36 9.94922 18.92 9.94922H21C21.56 9.96922 22 10.4192 22 10.9692Z"
        stroke="#4762F0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.48 10.55C17.06 10.96 16.82 11.55 16.88 12.18C16.97 13.26 17.96 14.05 19.04 14.05H21V15.5C21 18.5 19 20.5 16 20.5H7C4 20.5 2 18.5 2 15.5V8.5C2 5.78 3.64 3.88 6.19 3.56C6.45 3.52 6.72 3.5 7 3.5H16C16.26 3.5 16.51 3.50999 16.75 3.54999C19.33 3.84999 21 5.76 21 8.5V9.95001H18.92C18.36 9.95001 17.85 10.17 17.48 10.55Z"
        stroke="#4762F0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NavbarWalletIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 9H7"
        stroke="#A6A9B9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 10.9699V13.03C22 13.58 21.56 14.0299 21 14.0499H19.0399C17.9599 14.0499 16.97 13.2599 16.88 12.1799C16.82 11.5499 17.0599 10.9599 17.4799 10.5499C17.8499 10.1699 18.36 9.94995 18.92 9.94995H21C21.56 9.96995 22 10.4199 22 10.9699Z"
        stroke="#A6A9B9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.48 10.55C17.06 10.96 16.82 11.55 16.88 12.18C16.97 13.26 17.96 14.05 19.04 14.05H21V15.5C21 18.5 19 20.5 16 20.5H7C4 20.5 2 18.5 2 15.5V8.5C2 5.78 3.64 3.88 6.19 3.56C6.45 3.52 6.72 3.5 7 3.5H16C16.26 3.5 16.51 3.50999 16.75 3.54999C19.33 3.84999 21 5.76 21 8.5V9.95001H18.92C18.36 9.95001 17.85 10.17 17.48 10.55Z"
        stroke="#A6A9B9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const VerificationSuccessIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.75 26L23.25 31.5L34.25 20.5M50.75 26C50.75 29.2502 50.1098 32.4686 48.866 35.4714C47.6222 38.4742 45.7991 41.2026 43.5009 43.5009C41.2026 45.7991 38.4742 47.6222 35.4714 48.866C32.4686 50.1098 29.2502 50.75 26 50.75C22.7498 50.75 19.5314 50.1098 16.5286 48.866C13.5258 47.6222 10.7974 45.7991 8.49911 43.5009C6.20086 41.2026 4.37779 38.4742 3.13398 35.4714C1.89018 32.4686 1.25 29.2502 1.25 26C1.25 19.4359 3.85758 13.1406 8.49911 8.49911C13.1406 3.85758 19.4359 1.25 26 1.25C32.5641 1.25 38.8594 3.85758 43.5009 8.49911C48.1424 13.1406 50.75 19.4359 50.75 26Z"
        stroke="#00DD9A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CountryIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 0C12.8098 0 16.5 3.68984 16.5 8.25C16.5 12.8098 12.8102 16.5 8.25 16.5C3.6902 16.5 0 12.8102 0 8.25C0 3.6902 3.68984 0 8.25 0ZM11.4422 1.70005C11.6918 2.38 11.9014 3.07119 12.0706 3.77205C12.5649 3.62185 13.0513 3.44173 13.5286 3.23187C12.9242 2.59691 12.2199 2.0799 11.4422 1.70005ZM14.1688 4.00383C13.551 4.28994 12.9187 4.52912 12.2738 4.72097C12.4609 5.71976 12.5679 6.73635 12.5933 7.7666H15.517C15.428 6.39887 14.9619 5.10437 14.1688 4.00383ZM14.1688 12.4962C14.9619 11.3956 15.428 10.1011 15.517 8.7334H12.5933C12.5679 9.76365 12.4609 10.7802 12.2738 11.779C12.9187 11.9709 13.5509 12.2101 14.1688 12.4962ZM13.5286 13.2682C13.0513 13.0583 12.565 12.8782 12.0706 12.728C11.9014 13.4288 11.6918 14.12 11.4422 14.8C12.2195 14.4203 12.9239 13.9034 13.5286 13.2682ZM8.7334 15.517C9.2411 15.484 9.73877 15.3992 10.2202 15.2649C10.6025 14.3586 10.9077 13.4295 11.1353 12.4817C10.3517 12.3065 9.54983 12.204 8.7334 12.175V15.517ZM8.7334 11.2077C9.61795 11.2369 10.4867 11.3465 11.3357 11.5356C11.5044 10.6162 11.6016 9.68092 11.6262 8.7334H8.7334V11.2077ZM8.7334 7.7666H11.6262C11.6016 6.81908 11.5044 5.88383 11.3357 4.96444C10.4867 5.15354 9.61795 5.26311 8.7334 5.29234V7.7666ZM8.7334 4.32497C9.54983 4.29599 10.3517 4.19355 11.1353 4.01833C10.9077 3.07051 10.6025 2.14136 10.2202 1.23515C9.73877 1.10076 9.2411 1.01601 8.7334 0.982975V4.32497ZM2.33121 4.00383C1.53811 5.10437 1.07202 6.39887 0.982975 7.7666H3.9067C3.93209 6.73635 4.03908 5.71976 4.22619 4.72097C3.58131 4.52912 2.94905 4.28994 2.33121 4.00383ZM2.97142 3.23184C3.44873 3.44173 3.93502 3.62185 4.42944 3.77202C4.59863 3.07116 4.80817 2.37996 5.05783 1.70002C4.28046 2.07968 3.57612 2.59659 2.97142 3.23184ZM7.7666 0.982975C7.2589 1.01601 6.76123 1.10076 6.27983 1.23515C5.89746 2.14136 5.59228 3.07051 5.36466 4.01833C6.14834 4.19355 6.95017 4.29599 7.7666 4.32497V0.982975ZM7.7666 5.29234C6.88205 5.26311 6.01332 5.15354 5.16427 4.96444C4.9956 5.88383 4.89841 6.81908 4.87382 7.7666H7.7666V5.29234ZM6.27986 15.2648C6.76123 15.3992 7.2589 15.484 7.7666 15.517V12.175C6.95017 12.204 6.14834 12.3065 5.36466 12.4817C5.59231 13.4295 5.89746 14.3586 6.27986 15.2648ZM7.7666 11.2077V8.7334H4.87382C4.89841 9.68092 4.9956 10.6162 5.16427 11.5356C6.01332 11.3465 6.88205 11.2369 7.7666 11.2077ZM5.05783 14.8C4.80817 14.12 4.5986 13.4288 4.42944 12.7279C3.93506 12.8782 3.44873 13.0583 2.97142 13.2681C3.5758 13.9031 4.28008 14.4201 5.05783 14.8ZM2.33121 12.4962C2.94902 12.2101 3.58131 11.9709 4.22619 11.779C4.03908 10.7802 3.93209 9.76365 3.9067 8.7334H0.982975C1.07202 10.1011 1.53811 11.3956 2.33121 12.4962Z"
        fill="#9EACDB"
      />
    </svg>
  );
};
export const BellWithDotIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 0C12.8098 0 16.5 3.68984 16.5 8.25C16.5 12.8098 12.8102 16.5 8.25 16.5C3.6902 16.5 0 12.8102 0 8.25C0 3.6902 3.68984 0 8.25 0ZM11.4422 1.70005C11.6918 2.38 11.9014 3.07119 12.0706 3.77205C12.5649 3.62185 13.0513 3.44173 13.5286 3.23187C12.9242 2.59691 12.2199 2.0799 11.4422 1.70005ZM14.1688 4.00383C13.551 4.28994 12.9187 4.52912 12.2738 4.72097C12.4609 5.71976 12.5679 6.73635 12.5933 7.7666H15.517C15.428 6.39887 14.9619 5.10437 14.1688 4.00383ZM14.1688 12.4962C14.9619 11.3956 15.428 10.1011 15.517 8.7334H12.5933C12.5679 9.76365 12.4609 10.7802 12.2738 11.779C12.9187 11.9709 13.5509 12.2101 14.1688 12.4962ZM13.5286 13.2682C13.0513 13.0583 12.565 12.8782 12.0706 12.728C11.9014 13.4288 11.6918 14.12 11.4422 14.8C12.2195 14.4203 12.9239 13.9034 13.5286 13.2682ZM8.7334 15.517C9.2411 15.484 9.73877 15.3992 10.2202 15.2649C10.6025 14.3586 10.9077 13.4295 11.1353 12.4817C10.3517 12.3065 9.54983 12.204 8.7334 12.175V15.517ZM8.7334 11.2077C9.61795 11.2369 10.4867 11.3465 11.3357 11.5356C11.5044 10.6162 11.6016 9.68092 11.6262 8.7334H8.7334V11.2077ZM8.7334 7.7666H11.6262C11.6016 6.81908 11.5044 5.88383 11.3357 4.96444C10.4867 5.15354 9.61795 5.26311 8.7334 5.29234V7.7666ZM8.7334 4.32497C9.54983 4.29599 10.3517 4.19355 11.1353 4.01833C10.9077 3.07051 10.6025 2.14136 10.2202 1.23515C9.73877 1.10076 9.2411 1.01601 8.7334 0.982975V4.32497ZM2.33121 4.00383C1.53811 5.10437 1.07202 6.39887 0.982975 7.7666H3.9067C3.93209 6.73635 4.03908 5.71976 4.22619 4.72097C3.58131 4.52912 2.94905 4.28994 2.33121 4.00383ZM2.97142 3.23184C3.44873 3.44173 3.93502 3.62185 4.42944 3.77202C4.59863 3.07116 4.80817 2.37996 5.05783 1.70002C4.28046 2.07968 3.57612 2.59659 2.97142 3.23184ZM7.7666 0.982975C7.2589 1.01601 6.76123 1.10076 6.27983 1.23515C5.89746 2.14136 5.59228 3.07051 5.36466 4.01833C6.14834 4.19355 6.95017 4.29599 7.7666 4.32497V0.982975ZM7.7666 5.29234C6.88205 5.26311 6.01332 5.15354 5.16427 4.96444C4.9956 5.88383 4.89841 6.81908 4.87382 7.7666H7.7666V5.29234ZM6.27986 15.2648C6.76123 15.3992 7.2589 15.484 7.7666 15.517V12.175C6.95017 12.204 6.14834 12.3065 5.36466 12.4817C5.59231 13.4295 5.89746 14.3586 6.27986 15.2648ZM7.7666 11.2077V8.7334H4.87382C4.89841 9.68092 4.9956 10.6162 5.16427 11.5356C6.01332 11.3465 6.88205 11.2369 7.7666 11.2077ZM5.05783 14.8C4.80817 14.12 4.5986 13.4288 4.42944 12.7279C3.93506 12.8782 3.44873 13.0583 2.97142 13.2681C3.5758 13.9031 4.28008 14.4201 5.05783 14.8ZM2.33121 12.4962C2.94902 12.2101 3.58131 11.9709 4.22619 11.779C4.03908 10.7802 3.93209 9.76365 3.9067 8.7334H0.982975C1.07202 10.1011 1.53811 11.3956 2.33121 12.4962Z"
        fill="#9EACDB"
      />
    </svg>
  );
};

export const NavbarBellIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0206 2.90991C8.71058 2.90991 6.02058 5.59991 6.02058 8.90991V11.7999C6.02058 12.4099 5.76058 13.3399 5.45058 13.8599L4.30058 15.7699C3.59058 16.9499 4.08058 18.2599 5.38058 18.6999C9.69058 20.1399 14.3406 20.1399 18.6506 18.6999C19.8606 18.2999 20.3906 16.8699 19.7306 15.7699L18.5806 13.8599C18.2806 13.3399 18.0206 12.4099 18.0206 11.7999V8.90991C18.0206 5.60991 15.3206 2.90991 12.0206 2.90991Z"
        stroke="#191D31"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M13.87 3.19994C13.56 3.10994 13.24 3.03994 12.91 2.99994C11.95 2.87994 11.03 2.94994 10.17 3.19994C10.46 2.45994 11.18 1.93994 12.02 1.93994C12.86 1.93994 13.58 2.45994 13.87 3.19994Z"
        stroke="#191D31"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0195 19.0601C15.0195 20.7101 13.6695 22.0601 12.0195 22.0601C11.1995 22.0601 10.4395 21.7201 9.89953 21.1801C9.35953 20.6401 9.01953 19.8801 9.01953 19.0601"
        stroke="#191D31"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
export const ProfileWithDotIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="24" height="24" rx="12" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8009 22.1189C18.7032 23.9151 15.9784 25 13.0002 25C10.0219 25 7.29698 23.915 5.19922 22.1187C6.22462 18.7842 9.32927 16.3604 13 16.3604C16.6709 16.3604 19.7756 18.7843 20.8009 22.1189Z"
        fill="#9EACDB"
      />
      <circle cx="12.9997" cy="10.6003" r="4.32" fill="#9EACDB" />
      <rect
        x="1"
        y="1"
        width="24"
        height="24"
        rx="12"
        stroke="#9EACDB"
        strokeWidth="2"
      />
      <circle cx="21" cy="4" r="4" fill="#00DD9A" />
    </svg>
  );
};
export const HighVolatilityIcon = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4671 8.50895C11.1682 8.82313 11.3479 9.58519 11.0786 10.1862C11.0158 10.3261 10.9325 10.451 10.8336 10.5575C10.4843 10.9334 9.94018 11.0792 9.4198 10.846C8.75207 10.5468 8.55395 9.73638 8.80829 9.16881C9.06262 8.60124 9.76594 8.19477 10.4671 8.50895Z"
        fill="#BE010E"
      />
      <path
        d="M19 10C19 12.4469 18.0235 14.6657 16.439 16.288L14.8705 14.7195M19 10H16.8415M19 10C19 7.55313 18.0235 5.33432 16.439 3.71199M1 10C1 12.4469 1.97646 14.6657 3.56098 16.288L5.12947 14.7195M1 10H3.12195M1 10C1 7.55313 1.97646 5.33432 3.56098 3.71199M10 1C7.47631 1 5.19523 2.03874 3.56098 3.71199M10 1C12.5237 1 14.8048 2.03874 16.439 3.71199M10 1V3.23171M3.56098 3.71199L5.12947 5.28049M16.439 3.71199L14.8705 5.28049M10.8336 10.5575C10.4843 10.9334 9.94018 11.0792 9.4198 10.846C8.75207 10.5468 8.55395 9.73638 8.80829 9.16881C9.06262 8.60124 9.76594 8.19477 10.4671 8.50895C11.1682 8.82313 11.3479 9.58519 11.0786 10.1862C11.0158 10.3261 10.9325 10.451 10.8336 10.5575ZM10.8336 10.5575L13.7095 13.53"
        stroke="#BE010E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const MediumVolatilityIcon = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 10C19 12.4469 18.0235 14.6657 16.439 16.288L14.8705 14.7195M19 10H16.8415M19 10C19 7.55313 18.0235 5.33432 16.439 3.71199M1 10C1 12.4469 1.97646 14.6657 3.56098 16.288L5.12947 14.7195M1 10H3.12195M1 10C1 7.55313 1.97646 5.33432 3.56098 3.71199M10 1C7.47631 1 5.19523 2.03874 3.56098 3.71199M10 1C12.5237 1 14.8048 2.03874 16.439 3.71199M10 1V3.23171M3.56098 3.71199L5.12947 5.28049M16.439 3.71199L14.8705 5.28049"
        stroke="#FEA513"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3699 11.8421C8.09629 11.1242 8.50809 10.4583 9.12346 10.2238C9.26679 10.1691 9.41401 10.1397 9.55922 10.1344C10.0721 10.1156 10.5599 10.3972 10.763 10.9301C11.0236 11.6138 10.5906 12.327 10.0094 12.5485C9.42825 12.7699 8.64351 12.56 8.3699 11.8421Z"
        fill="#FEA513"
      />
      <path
        d="M9.55922 10.1344C10.0721 10.1156 10.5599 10.3972 10.763 10.9301C11.0236 11.6138 10.5906 12.327 10.0094 12.5485C9.42825 12.7699 8.64351 12.56 8.3699 11.8421C8.09629 11.1242 8.50809 10.4583 9.12346 10.2238C9.26679 10.1691 9.41401 10.1397 9.55922 10.1344ZM9.55922 10.1344L9.59339 8.06667L9.62757 5.99895"
        stroke="#FEA513"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LowVolatilityIcon = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 10C19 12.4469 18.0235 14.6657 16.439 16.288L14.8705 14.7195M19 10H16.8415M19 10C19 7.55313 18.0235 5.33432 16.439 3.71199M1 10C1 12.4469 1.97646 14.6657 3.56098 16.288L5.12947 14.7195M1 10H3.12195M1 10C1 7.55313 1.97646 5.33432 3.56098 3.71199M10 1C7.47631 1 5.19523 2.03874 3.56098 3.71199M10 1C12.5237 1 14.8048 2.03874 16.439 3.71199M10 1V3.23171M3.56098 3.71199L5.12947 5.28049M16.439 3.71199L14.8705 5.28049"
        stroke="#0EA87A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0214 9.76562C11.7073 10.4667 10.9452 10.6464 10.3442 10.3771C10.2043 10.3144 10.0794 10.2311 9.97292 10.1322C9.59697 9.78285 9.4512 9.23875 9.68439 8.71836C9.9836 8.05063 10.794 7.85251 11.3616 8.10685C11.9292 8.36118 12.3356 9.0645 12.0214 9.76562Z"
        fill="#0EA87A"
      />
      <path
        d="M9.97292 10.1322C9.59697 9.78285 9.4512 9.23875 9.68439 8.71836C9.9836 8.05063 10.794 7.85251 11.3616 8.10685C11.9292 8.36118 12.3356 9.0645 12.0214 9.76562C11.7073 10.4667 10.9452 10.6464 10.3442 10.3771C10.2043 10.3144 10.0794 10.2311 9.97292 10.1322ZM9.97292 10.1322L8.48666 11.5701L7.0004 13.0081"
        stroke="#0EA87A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AprMeterIcon = () => {
  return (
    <svg
      width="46"
      height="48"
      viewBox="0 0 46 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46 23.6571C46 19.5044 44.9372 15.4249 42.9185 11.8286L38.9348 14.1943C40.5498 17.0713 41.4 20.335 41.4 23.6571H46Z"
        fill="#2BA24C"
      />
      <path
        d="M42.9185 11.8286C40.8999 8.23222 37.9964 5.2458 34.5 3.16945L32.2 7.26699C34.9971 8.92806 37.3199 11.3172 38.9348 14.1943L42.9185 11.8286Z"
        fill="#056F22"
      />
      <path
        d="M34.5302 3.18743C31.0003 1.08388 26.99 -0.016136 22.9106 0.000178818L22.9284 4.73157C26.192 4.71852 29.4003 5.59853 32.2242 7.28137L34.5302 3.18743Z"
        fill="#FEA513"
      />
      <path
        d="M23 0C18.9626 -4.95204e-08 14.9964 1.09311 11.5 3.16945L13.8 7.26699C16.5971 5.60591 19.7701 4.73142 23 4.73142V0Z"
        fill="#D18303"
      />
      <path
        d="M11.5168 3.15947C7.98225 5.25437 5.05297 8.27851 3.02935 11.9218L7.02348 14.2689C8.64237 11.3542 10.9858 8.93492 13.8135 7.259L11.5168 3.15947Z"
        fill="#C20A07"
      />
      <path
        d="M3.05846 11.8695C1.04679 15.47 -0.00802489 19.5517 4.59564e-05 23.7044L4.60003 23.695C4.59358 20.3728 5.43743 17.1074 7.04677 14.2271L3.05846 11.8695Z"
        fill="#F23936"
      />
    </svg>
  );
};
export const ModalCloseIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#4E66FF" />
      <path
        d="M20.2123 12.7865C20.0482 12.6224 19.8257 12.5302 19.5936 12.5302C19.3615 12.5302 19.139 12.6224 18.9749 12.7865L16.5 15.2614L14.0251 12.7865C13.861 12.6224 13.6385 12.5302 13.4064 12.5302C13.1743 12.5302 12.9518 12.6224 12.7877 12.7865C12.6236 12.9506 12.5314 13.1732 12.5314 13.4052C12.5314 13.6373 12.6236 13.8599 12.7877 14.024L15.2626 16.4988L12.7877 18.9737C12.6236 19.1378 12.5314 19.3604 12.5314 19.5924C12.5314 19.8245 12.6236 20.0471 12.7877 20.2112C12.9518 20.3752 13.1743 20.4674 13.4064 20.4674C13.6385 20.4674 13.861 20.3752 14.0251 20.2112L16.5 17.7363L18.9749 20.2112C19.139 20.3752 19.3615 20.4674 19.5936 20.4674C19.8257 20.4674 20.0482 20.3752 20.2123 20.2112C20.3764 20.0471 20.4686 19.8245 20.4686 19.5924C20.4686 19.3604 20.3764 19.1378 20.2123 18.9737L17.7374 16.4988L20.2123 14.024C20.3764 13.8599 20.4686 13.6373 20.4686 13.4052C20.4686 13.1732 20.3764 12.9506 20.2123 12.7865Z"
        fill="white"
      />
    </svg>
  );
};
export const EnableTFAIcon = () => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.63608 14.3637C2.80034 13.528 2.13739 12.5359 1.68509 11.4439C1.2328 10.352 1 9.18165 1 7.99974C1 6.81784 1.2328 5.6475 1.68509 4.55557C2.13739 3.46363 2.80034 2.47147 3.63608 1.63574M16.3641 1.63574C17.1998 2.47147 17.8628 3.46363 18.3151 4.55557C18.7674 5.6475 19.0002 6.81784 19.0002 7.99974C19.0002 9.18165 18.7674 10.352 18.3151 11.4439C17.8628 12.5359 17.1998 13.528 16.3641 14.3637M6.46408 11.5347C5.52672 10.5971 5.00015 9.32556 5.00015 7.99974C5.00015 6.67392 5.52672 5.40238 6.46408 4.46474M13.5361 4.46474C14.4734 5.40238 15 6.67392 15 7.99974C15 9.32556 14.4734 10.5971 13.5361 11.5347M11.0001 7.99974C11.0001 8.26496 10.8947 8.51931 10.7072 8.70685C10.5196 8.89438 10.2653 8.99974 10.0001 8.99974C9.73486 8.99974 9.48051 8.89438 9.29297 8.70685C9.10544 8.51931 9.00008 8.26496 9.00008 7.99974C9.00008 7.73453 9.10544 7.48017 9.29297 7.29264C9.48051 7.1051 9.73486 6.99974 10.0001 6.99974C10.2653 6.99974 10.5196 7.1051 10.7072 7.29264C10.8947 7.48017 11.0001 7.73453 11.0001 7.99974Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TFAEnabledIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="18"
        height="18"
        rx="9"
        fill="#34FFC1"
        stroke="#007D23"
        strokeWidth="2"
      />
      <rect
        x="8"
        y="11"
        width="4"
        height="4"
        rx="2"
        fill="#34FFC1"
        stroke="#007D23"
        strokeWidth="2"
      />
      <line
        x1="10"
        y1="10"
        x2="10"
        y2="6"
        stroke="#007D23"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const ChainIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.49416 8.02571C8.37416 8.02571 8.25416 8.07142 8.16275 8.16306C7.43174 8.89407 6.24228 8.89431 5.51103 8.16306C5.32822 7.98001 5.03104 7.98001 4.84822 8.16306C4.66518 8.3461 4.66518 8.64282 4.84822 8.82587C5.94486 9.92274 7.72916 9.92251 8.82557 8.82587C9.00861 8.64282 9.00861 8.3461 8.82557 8.16306C8.73416 8.07142 8.61393 8.02571 8.49416 8.02571Z"
        fill="#A6A9B9"
        stroke="#A6A9B9"
        strokeWidth="0.3"
      />
      <path
        d="M8.16294 5.35014C7.44271 5.35014 6.72248 5.62436 6.17427 6.17256C5.99123 6.35561 5.99123 6.65232 6.17427 6.83537C6.35708 7.01842 6.65427 7.01842 6.83709 6.83537C7.5681 6.10436 8.75755 6.10412 9.4888 6.83537C9.67162 7.01842 9.9688 7.01842 10.1516 6.83537C10.3347 6.65232 10.3347 6.35561 10.1516 6.17256C9.60318 5.62436 8.88294 5.35014 8.16294 5.35014Z"
        fill="#A6A9B9"
        stroke="#A6A9B9"
        strokeWidth="0.3"
      />
      <path
        d="M9.81977 6.03787C9.69977 6.03787 9.57977 6.08357 9.48836 6.17521C9.30531 6.35826 9.30531 6.65498 9.48836 6.83803L12.1068 9.45646C12.2896 9.63951 12.5868 9.63951 12.7696 9.45646C12.9527 9.27342 12.9527 8.9767 12.7696 8.79365L10.1512 6.17521C10.0598 6.08357 9.93977 6.03787 9.81977 6.03787Z"
        fill="#A6A9B9"
        stroke="#A6A9B9"
        strokeWidth="0.3"
      />
      <path
        d="M5.87592 2.09107C5.75592 2.09107 5.63592 2.13678 5.54451 2.22842C5.36146 2.41146 5.36146 2.70818 5.54451 2.89123L7.00818 4.3549C7.191 4.53795 7.48818 4.53795 7.671 4.3549C7.85404 4.17186 7.85404 3.87514 7.671 3.69209L6.20732 2.22842C6.11592 2.13678 5.99592 2.09107 5.87592 2.09107Z"
        fill="#A6A9B9"
        stroke="#A6A9B9"
        strokeWidth="0.3"
      />
      <path
        d="M2.56146 5.40725C2.44146 5.40725 2.32146 5.45295 2.23006 5.54459C2.04701 5.72764 2.04701 6.02436 2.23006 6.2074L4.8485 8.82561C5.03154 9.00865 5.3285 9.00865 5.51131 8.82561C5.69436 8.64256 5.69436 8.34584 5.51131 8.16279L2.89287 5.54459C2.80123 5.45318 2.68123 5.40725 2.56146 5.40725Z"
        fill="#A6A9B9"
        stroke="#A6A9B9"
        strokeWidth="0.3"
      />
      <path
        d="M7.6601 10.5049C7.5401 10.5049 7.42033 10.5506 7.32869 10.642C7.14564 10.8251 7.14564 11.1218 7.32869 11.3051L8.79236 12.769C8.97541 12.952 9.27213 12.952 9.45541 12.769C9.63846 12.5859 9.63846 12.2892 9.45541 12.1059L7.99174 10.642C7.9001 10.5508 7.77986 10.5049 7.6601 10.5049Z"
        fill="#A6A9B9"
        stroke="#A6A9B9"
        strokeWidth="0.3"
      />
      <path
        d="M4.21865 1.42029C3.49373 1.42029 2.76881 1.68982 2.22998 2.22889C1.15186 3.30701 1.15186 5.12834 2.22998 6.20646C2.41279 6.38951 2.70998 6.38951 2.89279 6.20646C3.07584 6.02342 3.07584 5.7267 2.89279 5.54365C2.1742 4.82506 2.1742 3.61053 2.89279 2.89193C3.61139 2.17334 4.82592 2.17334 5.54451 2.89193C5.72732 3.07498 6.02451 3.07498 6.20732 2.89193C6.39037 2.70889 6.39037 2.41217 6.20732 2.22912C5.6685 1.68982 4.94357 1.42029 4.21865 1.42029Z"
        fill="#A6A9B9"
        stroke="#A6A9B9"
        strokeWidth="0.3"
      />
      <path
        d="M12.4384 8.65484C12.3184 8.65484 12.1984 8.70055 12.107 8.79219C11.924 8.97523 11.924 9.27195 12.107 9.455C12.8256 10.1736 12.8256 11.3881 12.107 12.1067C11.3884 12.8253 10.1739 12.8253 9.45528 12.1067C9.27247 11.9237 8.97528 11.9237 8.79247 12.1067C8.60942 12.2898 8.60942 12.5865 8.79247 12.7695C9.87059 13.8477 11.6919 13.8477 12.77 12.7695C13.8482 11.6914 13.8482 9.87008 12.77 8.79195C12.6784 8.70055 12.5584 8.65484 12.4384 8.65484Z"
        fill="#A6A9B9"
        stroke="#A6A9B9"
        strokeWidth="0.3"
      />
    </svg>
  );
};
export const ConvertorIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.66732 3.08333H10.6673M10.6673 3.08333L8.33398 0.75M10.6673 3.08333L8.33398 5.41667M8.33398 8.91667H1.33398M1.33398 8.91667L3.66732 11.25M1.33398 8.91667L3.66732 6.58333"
        stroke="#9EACDB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CalendarIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 4.25V1.25M11 4.25V1.25M4.25 7.25H11.75M2.75 14.75H13.25C13.6478 14.75 14.0294 14.592 14.3107 14.3107C14.592 14.0294 14.75 13.6478 14.75 13.25V4.25C14.75 3.85218 14.592 3.47064 14.3107 3.18934C14.0294 2.90804 13.6478 2.75 13.25 2.75H2.75C2.35218 2.75 1.97064 2.90804 1.68934 3.18934C1.40804 3.47064 1.25 3.85218 1.25 4.25V13.25C1.25 13.6478 1.40804 14.0294 1.68934 14.3107C1.97064 14.592 2.35218 14.75 2.75 14.75Z"
        stroke="#9EACDB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StarOutlineIcon = () => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.386 1.69075C10.686 0.76975 11.989 0.76975 12.288 1.69075L13.807 6.36475C13.8724 6.56524 13.9995 6.73993 14.1701 6.86385C14.3407 6.98778 14.5461 7.0546 14.757 7.05475H19.672C20.641 7.05475 21.043 8.29475 20.26 8.86475L16.284 11.7528C16.1132 11.8769 15.9861 12.052 15.9209 12.2528C15.8557 12.4536 15.8557 12.6699 15.921 12.8708L17.439 17.5448C17.739 18.4668 16.684 19.2328 15.901 18.6628L11.925 15.7747C11.7541 15.6505 11.5483 15.5836 11.337 15.5836C11.1257 15.5836 10.9199 15.6505 10.749 15.7747L6.77301 18.6628C5.99001 19.2328 4.93501 18.4658 5.23501 17.5448L6.75301 12.8708C6.81829 12.6699 6.81833 12.4536 6.75312 12.2528C6.68791 12.052 6.5608 11.8769 6.39001 11.7528L2.41401 8.86475C1.63001 8.29475 2.03401 7.05475 3.00201 7.05475H7.91601C8.12706 7.05481 8.33271 6.98809 8.50353 6.86415C8.67435 6.74021 8.80158 6.5654 8.86701 6.36475L10.386 1.69075V1.69075Z"
        stroke="#9EACDB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TooltipIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM9 4C9 4.26522 8.89464 4.51957 8.70711 4.70711C8.51957 4.89464 8.26522 5 8 5C7.73478 5 7.48043 4.89464 7.29289 4.70711C7.10536 4.51957 7 4.26522 7 4C7 3.73478 7.10536 3.48043 7.29289 3.29289C7.48043 3.10536 7.73478 3 8 3C8.26522 3 8.51957 3.10536 8.70711 3.29289C8.89464 3.48043 9 3.73478 9 4ZM7 7C6.73478 7 6.48043 7.10536 6.29289 7.29289C6.10536 7.48043 6 7.73478 6 8C6 8.26522 6.10536 8.51957 6.29289 8.70711C6.48043 8.89464 6.73478 9 7 9V12C7 12.2652 7.10536 12.5196 7.29289 12.7071C7.48043 12.8946 7.73478 13 8 13H9C9.26522 13 9.51957 12.8946 9.70711 12.7071C9.89464 12.5196 10 12.2652 10 12C10 11.7348 9.89464 11.4804 9.70711 11.2929C9.51957 11.1054 9.26522 11 9 11V8C9 7.73478 8.89464 7.48043 8.70711 7.29289C8.51957 7.10536 8.26522 7 8 7H7Z"
        fill="#9EACDB"
      />
    </svg>
  );
};
export const GoogleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="24px"
      height="24px"
    >
      <path
        fill="#FFC107"
        d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
      />
      <path
        fill="#FF3D00"
        d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
      />
      <path
        fill="#4CAF50"
        d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
      />
      <path
        fill="#1976D2"
        d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
      />
    </svg>
  );
};
export const FacebookIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0903 24V15.5629H7.01188V12.1425H10.0903V8.8361C10.0903 6.21378 12.3705 4.73159 14.7078 4.73159C15.8936 4.73159 16.9501 4.92162 17.3302 5.01663V7.92399H15.734C14.7078 7.92399 13.8527 8.60808 13.8527 9.69121V12.1425H17.1591L16.5891 15.5629H13.8527V24C20.2375 22.8029 23.943 17.524 23.943 12.1425C23.943 5.5867 18.6413 0 11.9145 0C5.5867 0 0 4.95962 0 12.1425C0 18.1283 4.04751 22.8029 10.0903 24Z"
        fill="#1977F3"
      />
    </svg>
  );
};
export const DropdownIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.29279 7.30529C5.48031 7.11782 5.73462 7.0125 5.99979 7.0125C6.26495 7.0125 6.51926 7.11782 6.70679 7.30529L9.99979 10.5983L13.2928 7.30529C13.385 7.20978 13.4954 7.1336 13.6174 7.08119C13.7394 7.02878 13.8706 7.00119 14.0034 7.00004C14.1362 6.99888 14.2678 7.02419 14.3907 7.07447C14.5136 7.12475 14.6253 7.199 14.7192 7.29289C14.8131 7.38679 14.8873 7.49844 14.9376 7.62133C14.9879 7.74423 15.0132 7.87591 15.012 8.00869C15.0109 8.14147 14.9833 8.27269 14.9309 8.39469C14.8785 8.5167 14.8023 8.62704 14.7068 8.71929L10.7068 12.7193C10.5193 12.9068 10.265 13.0121 9.99979 13.0121C9.73462 13.0121 9.48031 12.9068 9.29279 12.7193L5.29279 8.71929C5.10532 8.53176 5 8.27745 5 8.01229C5 7.74712 5.10532 7.49282 5.29279 7.30529Z"
        fill="#9EACDB"
      />
    </svg>
  );
};

export const RefreshIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.99948 9.39128C2.14948 9.39128 2.29798 9.32428 2.39598 9.19628L2.61348 8.91378C2.93898 10.8448 4.29148 12.4968 6.21148 13.1633C6.80248 13.3683 7.40898 13.4668 8.00748 13.4668C9.79948 13.4668 11.524 12.5828 12.5565 11.0263C12.709 10.7963 12.646 10.4858 12.416 10.3333C12.185 10.1798 11.876 10.2438 11.7225 10.4738C10.598 12.1708 8.46648 12.8888 6.53998 12.2188C4.94148 11.6638 3.82648 10.2723 3.58848 8.65628L4.01648 8.98578C4.23598 9.15328 4.54948 9.11328 4.71748 8.89428C4.88598 8.67528 4.84548 8.36178 4.62648 8.19328C4.62648 8.19328 3.44398 7.28278 3.44098 7.28078C3.19248 7.08928 2.83898 6.98178 2.61398 7.27528L1.60398 8.58678C1.43548 8.80578 1.47598 9.11928 1.69498 9.28778C1.78548 9.35728 1.89298 9.39128 1.99948 9.39128Z"
        fill="#5A5A5A"
      />
      <path
        d="M3.58505 5.66502C3.81455 5.81752 4.12505 5.75452 4.27855 5.52452C5.40305 3.82802 7.53655 3.11002 9.46105 3.77952C11.0596 4.33452 12.1746 5.72602 12.4126 7.34202L11.9846 7.01252C11.7651 6.84452 11.4516 6.88452 11.2836 7.10402C11.1151 7.32302 11.1556 7.63652 11.3746 7.80502C11.3746 7.80502 12.5571 8.71502 12.5601 8.71752C12.8131 8.91202 13.1586 9.02102 13.3871 8.72302L14.3971 7.41152C14.5656 7.19252 14.5251 6.87902 14.3061 6.71052C14.0871 6.54202 13.7731 6.58302 13.6051 6.80202L13.3876 7.08452C13.0621 5.15352 11.7096 3.50152 9.78955 2.83502C7.42955 2.01602 4.82155 2.89452 3.44455 4.97152C3.29205 5.20202 3.35505 5.51202 3.58505 5.66502Z"
        fill="#5A5A5A"
      />
    </svg>
  );
};
export const GreenUpArrowIcon = () => {
  return (
    <svg
      width="6"
      height="5"
      viewBox="0 0 6 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.00070657 4.1709C0.00597658 4.0624 0.0406014 3.95738 0.100887 3.86702L2.50082 0.267126C2.55561 0.184954 2.62984 0.117579 2.71692 0.0709801C2.804 0.0243812 2.90124 -1.35451e-07 3 -1.31134e-07C3.09876 -1.26817e-07 3.196 0.0243812 3.28308 0.0709802C3.37016 0.117579 3.44439 0.184954 3.49918 0.267126L5.89911 3.86702C5.9594 3.95738 5.99402 4.06241 5.99929 4.1709C6.00456 4.27939 5.98028 4.38728 5.92904 4.48306C5.87779 4.57883 5.80151 4.6589 5.70832 4.71472C5.61514 4.77053 5.50855 4.80001 5.39993 4.79999L3.72118 4.79999L2.27882 4.79999L0.600072 4.79999C0.491449 4.80001 0.38486 4.77053 0.291675 4.71472C0.198491 4.6589 0.122207 4.57883 0.0709632 4.48306C0.0197189 4.38728 -0.00456344 4.27939 0.00070657 4.1709Z"
        fill="#0EA97A"
      />
    </svg>
  );
};
export const RedDownArrowIcon = () => {
  return (
    <svg
      transform="rotate(180)"
      width="6"
      height="5"
      viewBox="0 0 6 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.00070649 4.1709C0.0059765 4.0624 0.0406016 3.95738 0.100887 3.86702L2.50082 0.267126C2.55561 0.184954 2.62984 0.117579 2.71692 0.0709801C2.804 0.0243812 2.90124 -1.35451e-07 3 -1.31134e-07C3.09876 -1.26817e-07 3.196 0.0243812 3.28308 0.0709802C3.37016 0.117579 3.44439 0.184954 3.49918 0.267126L5.89911 3.86702C5.9594 3.95738 5.99402 4.06241 5.99929 4.1709C6.00456 4.27939 5.98028 4.38728 5.92904 4.48306C5.87779 4.57883 5.80151 4.6589 5.70832 4.71472C5.61514 4.77053 5.50855 4.80001 5.39993 4.79999L3.72118 4.79999L2.27882 4.79999L0.600072 4.79999C0.491449 4.80001 0.38486 4.77053 0.291675 4.71472C0.198491 4.6589 0.122207 4.57883 0.0709632 4.48306C0.0197189 4.38728 -0.00456352 4.27939 0.00070649 4.1709Z"
        fill="#FF3E01"
      />
    </svg>
  );
};
export const DollarIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#008D3D" />
      <path
        d="M11.08 18.859V17.2H12.767V18.859H11.08ZM11.08 7.659V6H12.767V7.659H11.08ZM11.962 17.676C11.2527 17.676 10.618 17.5453 10.058 17.284C9.498 17.0227 9.03833 16.654 8.679 16.178C8.32433 15.702 8.098 15.1373 8 14.484L9.666 14.218C9.79667 14.792 10.0767 15.2493 10.506 15.59C10.94 15.926 11.458 16.094 12.06 16.094C12.6387 16.094 13.1147 15.9587 13.488 15.688C13.8613 15.4127 14.048 15.065 14.048 14.645C14.048 14.351 13.9593 14.113 13.782 13.931C13.6047 13.7443 13.32 13.5903 12.928 13.469L10.499 12.713C9.085 12.2743 8.378 11.4157 8.378 10.137C8.378 9.53967 8.52033 9.01933 8.805 8.576C9.09433 8.128 9.50033 7.785 10.023 7.547C10.5457 7.30433 11.1617 7.18533 11.871 7.19C12.529 7.19467 13.1147 7.31367 13.628 7.547C14.146 7.78033 14.5753 8.11633 14.916 8.555C15.2613 8.99367 15.5063 9.521 15.651 10.137L13.922 10.452C13.8567 10.1207 13.7283 9.829 13.537 9.577C13.3457 9.325 13.1053 9.129 12.816 8.989C12.5267 8.849 12.2047 8.77433 11.85 8.765C11.5093 8.76033 11.2037 8.814 10.933 8.926C10.6623 9.03333 10.4477 9.18733 10.289 9.388C10.1303 9.584 10.051 9.80567 10.051 10.053C10.051 10.3283 10.1607 10.564 10.38 10.76C10.604 10.956 10.9563 11.124 11.437 11.264L13.25 11.789C14.1227 12.041 14.7503 12.384 15.133 12.818C15.5203 13.2473 15.714 13.819 15.714 14.533C15.714 15.1583 15.5577 15.7067 15.245 16.178C14.9323 16.6493 14.4937 17.018 13.929 17.284C13.3643 17.5453 12.7087 17.676 11.962 17.676Z"
        fill="white"
      />
    </svg>
  );
};
export const CloseSidebarIcon = ({ size = "27" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="27" height="27" rx="8" fill="#172683" />
      <path
        d="M5.5 7.74935C5.5 7.28912 5.8731 6.91602 6.33333 6.91602L19.6667 6.91602C20.1269 6.91602 20.5 7.28912 20.5 7.74935C20.5 8.20958 20.1269 8.58268 19.6667 8.58268L6.33333 8.58268C5.8731 8.58268 5.5 8.20958 5.5 7.74935Z"
        fill="#F8FAFB"
      />
      <path
        d="M5.5 20.2493C5.5 19.7891 5.8731 19.416 6.33333 19.416H19.6667C20.1269 19.416 20.5 19.7891 20.5 20.2493C20.5 20.7096 20.1269 21.0827 19.6667 21.0827H6.33333C5.8731 21.0827 5.5 20.7096 5.5 20.2493Z"
        fill="#F8FAFB"
      />
      <path
        d="M13.0003 11.082C12.5401 11.082 12.167 11.4551 12.167 11.9154C12.167 12.3756 12.5401 12.7487 13.0003 12.7487H19.667C20.1272 12.7487 20.5003 12.3756 20.5003 11.9154C20.5003 11.4551 20.1272 11.082 19.667 11.082L13.0003 11.082Z"
        fill="#F8FAFB"
      />
      <path
        d="M12.167 16.0833C12.167 15.6231 12.5401 15.25 13.0003 15.25L19.667 15.25C20.1272 15.25 20.5003 15.6231 20.5003 16.0833C20.5003 16.5436 20.1272 16.9167 19.667 16.9167H13.0003C12.5401 16.9167 12.167 16.5436 12.167 16.0833Z"
        fill="#F8FAFB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 11.5833C10.5 11.2677 10.3217 10.9791 10.0393 10.838C9.75703 10.6968 9.41918 10.7273 9.16667 10.9167L5.83333 13.4167C5.62349 13.5741 5.5 13.8211 5.5 14.0833C5.5 14.3457 5.62349 14.5927 5.83333 14.75L9.16667 17.25C9.41918 17.4394 9.75703 17.4698 10.0393 17.3287C10.3217 17.1875 10.5 16.899 10.5 16.5833V11.5833ZM8.83333 14.9167L7.72222 14.0833L8.83333 13.25V14.9167Z"
        fill="#F8FAFB"
      />
    </svg>
  );
};
export const OpenSidebarIcon = () => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27 19C27 23.4183 23.4183 27 19 27L0 27L2.36041e-06 -2.36041e-06L19 -6.99382e-07C23.4183 -3.13124e-07 27 3.58172 27 8L27 19Z"
        fill="#172683"
      />
      <path
        d="M20.5 19.2487C20.5 19.7089 20.1269 20.082 19.6667 20.082L6.33333 20.082C5.87308 20.082 5.5 19.7089 5.5 19.2487C5.5 18.7885 5.87308 18.4154 6.33333 18.4154L19.6667 18.4154C20.1269 18.4154 20.5 18.7885 20.5 19.2487Z"
        fill="#F8FAFB"
      />
      <path
        d="M20.5 6.7487C20.5 7.20895 20.1269 7.58203 19.6667 7.58203L6.33333 7.58203C5.87308 7.58203 5.5 7.20895 5.5 6.7487C5.5 6.28845 5.87308 5.91536 6.33333 5.91536L19.6667 5.91536C20.1269 5.91536 20.5 6.28845 20.5 6.7487Z"
        fill="#F8FAFB"
      />
      <path
        d="M12.9997 15.9141C13.4599 15.9141 13.833 15.541 13.833 15.0807C13.833 14.6205 13.4599 14.2474 12.9997 14.2474L6.33301 14.2474C5.87276 14.2474 5.49967 14.6205 5.49967 15.0807C5.49967 15.541 5.87276 15.9141 6.33301 15.9141L12.9997 15.9141Z"
        fill="#F8FAFB"
      />
      <path
        d="M13.833 10.9167C13.833 11.3769 13.4599 11.75 12.9997 11.75L6.33301 11.75C5.87276 11.75 5.49967 11.3769 5.49967 10.9167C5.49967 10.4564 5.87276 10.0833 6.33301 10.0833L12.9997 10.0833C13.4599 10.0833 13.833 10.4564 13.833 10.9167Z"
        fill="#F8FAFB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 15.4167C15.5 15.7323 15.6783 16.0209 15.9607 16.162C16.243 16.3032 16.5808 16.2727 16.8333 16.0833L20.1667 13.5833C20.3765 13.4259 20.5 13.1789 20.5 12.9167C20.5 12.6543 20.3765 12.4073 20.1667 12.25L16.8333 9.75001C16.5808 9.56059 16.243 9.53017 15.9607 9.67134C15.6783 9.81251 15.5 10.101 15.5 10.4167L15.5 15.4167ZM17.1667 12.0833L18.2778 12.9167L17.1667 13.75L17.1667 12.0833Z"
        fill="#F8FAFB"
      />
    </svg>
  );
};
export const LinkIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.09659 4.81543C5.02459 4.81543 4.95259 4.84285 4.89775 4.89783C4.45914 5.33644 3.74547 5.33658 3.30672 4.89783C3.19703 4.78801 3.01872 4.78801 2.90903 4.89783C2.7992 5.00766 2.7992 5.18569 2.90903 5.29552C3.56702 5.95365 4.63759 5.95351 5.29544 5.29552C5.40527 5.18569 5.40527 5.00766 5.29544 4.89783C5.24059 4.84285 5.16845 4.81543 5.09659 4.81543V4.81543Z"
        fill="#4762F0"
        stroke="#4762F0"
        strokeWidth="0.3"
      />
      <path
        d="M4.89813 3.21008C4.46599 3.21008 4.03385 3.37461 3.70493 3.70354C3.5951 3.81336 3.5951 3.99139 3.70493 4.10122C3.81462 4.21105 3.99293 4.21105 4.10262 4.10122C4.54123 3.66261 5.2549 3.66247 5.69365 4.10122C5.80334 4.21105 5.98165 4.21105 6.09134 4.10122C6.20116 3.99139 6.20116 3.81336 6.09134 3.70354C5.76227 3.37461 5.33013 3.21008 4.89813 3.21008V3.21008Z"
        fill="#4762F0"
        stroke="#4762F0"
        strokeWidth="0.3"
      />
      <path
        d="M5.89205 3.62233C5.82005 3.62233 5.74805 3.64975 5.69321 3.70474C5.58338 3.81457 5.58338 3.9926 5.69321 4.10243L7.26427 5.67349C7.37396 5.78332 7.55227 5.78332 7.66196 5.67349C7.77179 5.56366 7.77179 5.38563 7.66196 5.2758L6.0909 3.70474C6.03605 3.64975 5.96405 3.62233 5.89205 3.62233V3.62233Z"
        fill="#4762F0"
        stroke="#4762F0"
        strokeWidth="0.3"
      />
      <path
        d="M3.52584 1.25464C3.45384 1.25464 3.38184 1.28207 3.327 1.33705C3.21717 1.44688 3.21717 1.62491 3.327 1.73474L4.2052 2.61294C4.31489 2.72277 4.4932 2.72277 4.60289 2.61294C4.71272 2.50311 4.71272 2.32508 4.60289 2.21525L3.72469 1.33705C3.66984 1.28207 3.59784 1.25464 3.52584 1.25464Z"
        fill="#4762F0"
        stroke="#4762F0"
        strokeWidth="0.3"
      />
      <path
        d="M1.53707 3.24357C1.46507 3.24357 1.39307 3.27099 1.33823 3.32597C1.2284 3.4358 1.2284 3.61383 1.33823 3.72366L2.90929 5.29458C3.01912 5.40441 3.19729 5.40441 3.30698 5.29458C3.41681 5.18475 3.41681 5.00672 3.30698 4.89689L1.73592 3.32597C1.68093 3.27113 1.60893 3.24357 1.53707 3.24357Z"
        fill="#4762F0"
        stroke="#4762F0"
        strokeWidth="0.3"
      />
      <path
        d="M4.59616 6.30333C4.52416 6.30333 4.4523 6.33075 4.39731 6.3856C4.28748 6.49543 4.28748 6.67346 4.39731 6.78343L5.27552 7.66177C5.38534 7.7716 5.56338 7.7716 5.67334 7.66177C5.78317 7.55194 5.78317 7.37391 5.67334 7.26394L4.79514 6.3856C4.74016 6.33089 4.66802 6.30333 4.59616 6.30333Z"
        fill="#4762F0"
        stroke="#4762F0"
        strokeWidth="0.3"
      />
      <path
        d="M2.53139 0.852566C2.09643 0.852566 1.66148 1.01428 1.33818 1.33772C0.691309 1.9846 0.691309 3.07739 1.33818 3.72427C1.44787 3.8341 1.62618 3.8341 1.73587 3.72427C1.8457 3.61444 1.8457 3.43641 1.73587 3.32658C1.30471 2.89543 1.30471 2.16671 1.73587 1.73555C2.16703 1.30439 2.89575 1.30439 3.3269 1.73555C3.43659 1.84538 3.6149 1.84538 3.72459 1.73555C3.83442 1.62572 3.83442 1.44769 3.72459 1.33786C3.40129 1.01428 2.96634 0.852566 2.53139 0.852566Z"
        fill="#4762F0"
        stroke="#4762F0"
        strokeWidth="0.3"
      />
      <path
        d="M7.46329 5.19252C7.39129 5.19252 7.31929 5.21994 7.26445 5.27492C7.15462 5.38475 7.15462 5.56278 7.26445 5.67261C7.69561 6.10377 7.69561 6.83248 7.26445 7.26364C6.83329 7.6948 6.10457 7.6948 5.67342 7.26364C5.56373 7.15381 5.38542 7.15381 5.27573 7.26364C5.1659 7.37347 5.1659 7.5515 5.27573 7.66133C5.92261 8.3082 7.0154 8.3082 7.66228 7.66133C8.30915 7.01445 8.30915 5.92166 7.66228 5.27478C7.60729 5.21994 7.53529 5.19252 7.46329 5.19252V5.19252Z"
        fill="#4762F0"
        stroke="#4762F0"
        strokeWidth="0.3"
      />
    </svg>
  );
};

export const BackIcon = () => {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 6H13M6 11L1 6L6 11ZM1 6L6 1L1 6Z"
        stroke="#252A48"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_866_13523)">
        <path
          d="M6.17554 1.67969L0.673399 7.18223C0.645718 7.20999 0.62573 7.24505 0.616212 7.28272L0.00635232 9.73057C-0.0118903 9.80425 0.00976291 9.88262 0.0635391 9.93639C0.104228 9.97708 0.15967 9.99961 0.216381 9.99961C0.233751 9.99961 0.251518 9.99747 0.268809 9.9931L2.71666 9.38316C2.75481 9.37365 2.78947 9.35374 2.81715 9.32606L8.31977 3.82391L6.17554 1.67969Z"
          fill="#4762F0"
        />
        <path
          d="M9.68346 0.927153L9.07098 0.314676C8.66163 -0.0946735 7.94818 -0.0942769 7.53931 0.314676L6.78906 1.06492L8.93321 3.20907L9.68346 2.45882C9.88793 2.25442 10.0006 1.98237 10.0006 1.69303C10.0006 1.40368 9.88793 1.13163 9.68346 0.927153Z"
          fill="#4762F0"
        />
      </g>
      <defs>
        <clipPath id="clip0_866_13523">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const VerificationIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.00083 12.0008L11.0008 14.0008L15.0008 10.0008M7.83583 4.69783C8.55313 4.64058 9.23411 4.35853 9.78183 3.89183C10.4007 3.3641 11.1875 3.07422 12.0008 3.07422C12.8142 3.07422 13.6009 3.3641 14.2198 3.89183C14.7675 4.35853 15.4485 4.64058 16.1658 4.69783C16.9766 4.76233 17.7378 5.11365 18.3129 5.68875C18.888 6.26385 19.2393 7.02508 19.3038 7.83583C19.3611 8.55313 19.6431 9.23411 20.1098 9.78183C20.6376 10.4007 20.9274 11.1875 20.9274 12.0008C20.9274 12.8142 20.6376 13.6009 20.1098 14.2198C19.6431 14.7675 19.3611 15.4485 19.3038 16.1658C19.2393 16.9766 18.888 17.7378 18.3129 18.3129C17.7378 18.888 16.9766 19.2393 16.1658 19.3038C15.4485 19.3611 14.7675 19.6431 14.2198 20.1098C13.6009 20.6376 12.8142 20.9274 12.0008 20.9274C11.1875 20.9274 10.4007 20.6376 9.78183 20.1098C9.23411 19.6431 8.55313 19.3611 7.83583 19.3038C7.02508 19.2393 6.26385 18.888 5.68875 18.3129C5.11365 17.7378 4.76233 16.9766 4.69783 16.1658C4.64058 15.4485 4.35853 14.7675 3.89183 14.2198C3.3641 13.6009 3.07422 12.8142 3.07422 12.0008C3.07422 11.1875 3.3641 10.4007 3.89183 9.78183C4.35853 9.23411 4.64058 8.55313 4.69783 7.83583C4.76233 7.02508 5.11365 6.26385 5.68875 5.68875C6.26385 5.11365 7.02508 4.76233 7.83583 4.69783Z"
        stroke="#9EACDB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClockIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 8V12L15 15M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z"
        stroke="#252A48"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CopyCodeIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9401 2.97266H3.03721C2.29565 2.97266 1.69336 3.57495 1.69336 4.3165V15.6556C1.69336 16.3972 2.29565 16.9995 3.03721 16.9995H10.9401C11.6817 16.9995 12.284 16.3972 12.284 15.6556V4.3165C12.2805 3.57495 11.6782 2.97266 10.9401 2.97266ZM11.3405 15.6522C11.3405 15.875 11.1595 16.056 10.9367 16.056H3.03372C2.81091 16.056 2.62987 15.875 2.62987 15.6522V4.3165C2.62987 4.09369 2.81091 3.91265 3.03372 3.91265H10.9367C11.1595 3.91265 11.3405 4.09369 11.3405 4.3165V15.6522Z"
        fill="#9EACDB"
      />
      <path
        d="M13.9616 0H6.05869C5.31714 0 4.71484 0.602294 4.71484 1.34385C4.71484 1.60496 4.92373 1.81384 5.18484 1.81384C5.44595 1.81384 5.65484 1.60496 5.65484 1.34385C5.65484 1.12103 5.83588 0.939996 6.05869 0.939996H13.9616C14.1844 0.939996 14.3655 1.12103 14.3655 1.34385V12.683C14.3655 12.9058 14.1844 13.0868 13.9616 13.0868C13.7005 13.0868 13.4916 13.2957 13.4916 13.5568C13.4916 13.8179 13.7005 14.0268 13.9616 14.0268C14.7032 14.0268 15.3055 13.4245 15.3055 12.683V1.34385C15.3055 0.602294 14.7032 0 13.9616 0Z"
        fill="#9EACDB"
      />
    </svg>
  );
};

export const QrCode = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 134 134"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M92.125 0H134V41.875H92.125V0ZM100.5 33.5H125.625V8.375H100.5V33.5Z"
        fill="black"
      />
      <path d="M108.875 16.75H117.25V25.125H108.875V16.75Z" fill="black" />
      <path
        d="M41.875 0V41.875H0V0H41.875ZM8.375 33.5H33.5V8.375H8.375V33.5Z"
        fill="black"
      />
      <path d="M16.75 16.75H25.125V25.125H16.75V16.75Z" fill="black" />
      <path
        d="M134 134H92.125V92.125H134V134ZM125.625 100.5H100.5V125.625H125.625V100.5Z"
        fill="black"
      />
      <path d="M108.875 108.875H117.25V117.25H108.875V108.875Z" fill="black" />
      <path d="M50.25 0H67V8.375H50.25V0Z" fill="black" />
      <path
        d="M67 33.5H58.625V25.125H50.25V16.75H75.375V8.375H83.75V16.75V20.9375V25.125H67V33.5Z"
        fill="black"
      />
      <path d="M75.375 33.5H83.75V41.875H75.375V33.5Z" fill="black" />
      <path
        d="M50.25 41.875H58.625V50.25H83.75V58.625H50.25V41.875Z"
        fill="black"
      />
      <path
        d="M125.625 75.375H117.25V67H125.625V50.25H134V83.75H125.625V75.375Z"
        fill="black"
      />
      <path d="M108.875 50.25H117.25V58.625H108.875V50.25Z" fill="black" />
      <path
        d="M83.75 83.75H67V75.375H75.375V67H92.125V50.25H100.5V67H108.875V83.75H100.5V75.375H96.3125H92.125H83.75V83.75Z"
        fill="black"
      />
      <path d="M50.25 67H58.625V83.75H50.25V67Z" fill="black" />
      <path
        d="M58.625 92.125H83.75V100.5H67V125.625H83.75V134H58.625V125.625H41.875V117.25H58.625V92.125Z"
        fill="black"
      />
      <path d="M75.375 108.875H83.75V117.25H75.375V108.875Z" fill="black" />
      <path d="M41.875 92.125H50.25V108.875H41.875V92.125Z" fill="black" />
      <path
        d="M8.375 108.875H33.5V134H25.125V117.25H8.375V108.875Z"
        fill="black"
      />
      <path d="M0 125.625H16.75V134H0V125.625Z" fill="black" />
      <path d="M0 92.125H8.375V100.5H0V92.125Z" fill="black" />
      <path
        d="M33.5 100.5H25.125V75.375H41.875V83.75H33.5V100.5Z"
        fill="black"
      />
      <path
        d="M16.75 58.625H25.125V50.25H33.5V58.625H41.875V67H8.375V58.625H0V50.25H16.75V58.625Z"
        fill="black"
      />
      <path d="M0 75.375H16.75V83.75H0V75.375Z" fill="black" />
    </svg>
  );
};

export const WithdrawIcon = () => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_2)">
        <g filter="url(#filter0_d_1_2)">
          <rect x="1" width="37.5" height="37.5" rx="18.75" fill="#E9EEF8" />
        </g>
        <path
          d="M25 19.5L21.5 23.5H23.5L24 28.5H27V23.5H29.5L25.5 19.5H25Z"
          fill="#F23936"
        />
        <path
          d="M26.7277 29H24.2731C23.8223 29 23.4549 28.6258 23.4549 28.1667V24.0001H21.4095C21.2442 24.0001 21.0945 23.8984 21.0315 23.7426C20.9676 23.5868 21.0028 23.4076 21.1198 23.2885L25.2108 19.1219C25.3703 18.9594 25.6297 18.9594 25.7892 19.1219L29.8802 23.2885C29.9972 23.4076 30.0324 23.5868 29.9685 23.7426C29.9064 23.8984 29.7566 24.0001 29.5914 24.0001H27.5459V28.1667C27.5459 28.6258 27.1785 29 26.7277 29ZM22.397 23.1668H23.864C24.0898 23.1668 24.2731 23.3535 24.2731 23.5834V28.1667H26.7277V23.5834C26.7277 23.3535 26.911 23.1668 27.1368 23.1668H28.6038L25.5004 20.006L22.397 23.1668Z"
          fill="#373737"
        />
        <path
          d="M21.25 26H12.0833C10.935 26 10 25.1273 10 24.0556V13.9444C10 12.8727 10.935 12 12.0833 12H27.9167C29.065 12 30 12.8727 30 13.9444V20.9444C30 21.1591 29.8133 21.3333 29.5833 21.3333C29.3533 21.3333 29.1667 21.1591 29.1667 20.9444V13.9444C29.1667 13.3012 28.6058 12.7778 27.9167 12.7778H12.0833C11.3942 12.7778 10.8333 13.3012 10.8333 13.9444V24.0556C10.8333 24.6988 11.3942 25.2222 12.0833 25.2222H21.25C21.48 25.2222 21.6667 25.3964 21.6667 25.6111C21.6667 25.8258 21.48 26 21.25 26Z"
          fill="#373737"
        />
        <path
          d="M16 22H10.4C10.1792 22 10 21.832 10 21.625V16.375C10 16.168 10.1792 16 10.4 16H16C17.1024 16 18 16.8415 18 17.875V20.125C18 21.1585 17.1024 22 16 22ZM10.8 21.25H16C16.6616 21.25 17.2 20.7453 17.2 20.125V17.875C17.2 17.2547 16.6616 16.75 16 16.75H10.8V21.25Z"
          fill="#373737"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1_2"
          x="-32.75"
          y="-30"
          width="112.5"
          height="112.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.75" dy="7.5" />
          <feGaussianBlur stdDeviation="18.75" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0901961 0 0 0 0 0.14902 0 0 0 0 0.513726 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1_2"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1_2"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_1_2">
          <rect width="38" height="38" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DepositIcon = () => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_2)">
        <g filter="url(#filter0_d_1_2)">
          <rect width="37.5" height="37.5" rx="18.75" fill="#E9EEF8" />
        </g>
        <path
          d="M24 19.5V24V24.5H21.5L25.5 28.5L29.5 24.5H27.5L27 19.5H24Z"
          fill="#2BA24C"
        />
        <path
          d="M24.2723 19L26.7269 19C27.1777 19 27.5451 19.3742 27.5451 19.8333L27.5451 23.9999L29.5905 23.9999C29.7558 23.9999 29.9055 24.1016 29.9685 24.2574C30.0324 24.4132 29.9972 24.5924 29.8802 24.7115L25.7892 28.8781C25.6297 29.0406 25.3703 29.0406 25.2108 28.8781L21.1198 24.7115C21.0028 24.5924 20.9676 24.4132 21.0315 24.2574C21.0936 24.1016 21.2434 23.9999 21.4086 23.9999L23.4541 23.9999L23.4541 19.8333C23.4541 19.3742 23.8215 19 24.2723 19ZM28.603 24.8332L27.136 24.8332C26.9102 24.8332 26.7269 24.6465 26.7269 24.4166L26.7269 19.8333L24.2723 19.8333L24.2723 24.4166C24.2723 24.6465 24.089 24.8332 23.8632 24.8332L22.3962 24.8332L25.4996 27.994L28.603 24.8332Z"
          fill="#373737"
        />
        <path
          d="M20.25 26H11.0833C9.935 26 9 25.1273 9 24.0556V13.9444C9 12.8727 9.935 12 11.0833 12H26.9167C28.065 12 29 12.8727 29 13.9444V20.9444C29 21.1591 28.8133 21.3333 28.5833 21.3333C28.3533 21.3333 28.1667 21.1591 28.1667 20.9444V13.9444C28.1667 13.3012 27.6058 12.7778 26.9167 12.7778H11.0833C10.3942 12.7778 9.83333 13.3012 9.83333 13.9444V24.0556C9.83333 24.6988 10.3942 25.2222 11.0833 25.2222H20.25C20.48 25.2222 20.6667 25.3964 20.6667 25.6111C20.6667 25.8258 20.48 26 20.25 26Z"
          fill="#373737"
        />
        <path
          d="M15 22H9.4C9.1792 22 9 21.832 9 21.625V16.375C9 16.168 9.1792 16 9.4 16H15C16.1024 16 17 16.8415 17 17.875V20.125C17 21.1585 16.1024 22 15 22ZM9.8 21.25H15C15.6616 21.25 16.2 20.7453 16.2 20.125V17.875C16.2 17.2547 15.6616 16.75 15 16.75H9.8V21.25Z"
          fill="#373737"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1_2"
          x="-33.75"
          y="-30"
          width="112.5"
          height="112.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.75" dy="7.5" />
          <feGaussianBlur stdDeviation="18.75" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0901961 0 0 0 0 0.14902 0 0 0 0 0.513726 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1_2"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1_2"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_1_2">
          <rect width="38" height="38" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const VerifyIcon = () => {
  return (
    <>
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1922_1571)">
          <path
            d="M44.6807 19.2967C44.0646 18.8831 43.5081 18.3868 43.0269 17.8218C43.0626 17.0352 43.2207 16.2589 43.4956 15.521C44.0122 13.772 44.6556 11.5953 43.4156 9.89212C42.1666 8.17532 39.8849 8.11772 38.0518 8.07082C37.2807 8.10163 36.5092 8.0187 35.7623 7.82472C35.3516 7.18049 35.038 6.4793 34.8316 5.74372C34.22 4.00182 33.458 1.83382 31.4175 1.17072C29.4375 0.52722 27.6606 1.74982 26.0938 2.82502C25.4642 3.32775 24.7572 3.72516 24.0005 4.00182C23.2434 3.72545 22.5361 3.32801 21.9063 2.82502C20.3394 1.74892 18.562 0.53012 16.5825 1.17072C14.5425 1.83382 13.7808 4.00072 13.1685 5.74302C12.9625 6.47497 12.6524 7.17352 12.2476 7.81722C11.4983 8.01713 10.723 8.10243 9.9482 8.07022C8.1152 8.11702 5.8335 8.17472 4.5845 9.89142C3.3445 11.5956 3.9878 13.7723 4.5045 15.5214C4.77614 16.2554 4.93563 17.0261 4.9776 17.8076C4.49859 18.3806 3.94002 18.8821 3.3189 19.2968C1.84 20.4247 0 21.8289 0 24.0018C0 26.1747 1.84 27.5789 3.3193 28.7069C3.93545 29.1206 4.49191 29.6168 4.9731 30.1818C4.93739 30.9685 4.77926 31.7447 4.5044 32.4826C3.9878 34.2316 3.3444 36.4084 4.5844 38.1115C5.8334 39.8283 8.1151 39.8859 9.9482 39.9328C10.7193 39.902 11.4908 39.9849 12.2377 40.1789C12.6484 40.8232 12.962 41.5243 13.1684 42.2599C13.7807 44.0021 14.5424 46.1699 16.5829 46.8332C16.9444 46.9517 17.3225 47.012 17.7029 47.0119C19.2386 47.0119 20.6409 46.048 21.9066 45.1789C22.5362 44.6761 23.2432 44.2785 24 44.0018C24.7572 44.2782 25.4645 44.6756 26.0943 45.1786C27.6611 46.2547 29.438 47.4725 31.418 46.8329C33.458 46.1698 34.2197 44.0029 34.832 42.2606C35.038 41.5287 35.3481 40.8301 35.7529 40.1864C36.5022 39.9865 37.2775 39.9012 38.0523 39.9334C39.8853 39.8866 42.167 39.8289 43.416 38.1122C44.656 36.4081 44.0127 34.2313 43.496 32.4822C43.2244 31.7482 43.0649 30.9775 43.0229 30.196C43.5019 29.623 44.0605 29.1215 44.6816 28.7068C46.16 27.5789 48 26.1747 48 24.0018C48 21.8289 46.16 20.4247 44.6807 19.2967ZM32.9141 20.4159L22.9141 30.4159C22.7284 30.6017 22.508 30.749 22.2653 30.8495C22.0227 30.9501 21.7626 31.0018 21.5 31.0018C21.2374 31.0018 20.9773 30.9501 20.7347 30.8495C20.492 30.749 20.2716 30.6017 20.0859 30.4159L15.0859 25.4159C14.8963 25.2311 14.7453 25.0104 14.6417 24.7668C14.538 24.5231 14.4838 24.2613 14.4821 23.9966C14.4804 23.7318 14.5314 23.4693 14.6319 23.2244C14.7325 22.9794 14.8806 22.7569 15.0679 22.5697C15.2551 22.3825 15.4776 22.2343 15.7226 22.1337C15.9675 22.0332 16.23 21.9823 16.4948 21.9839C16.7595 21.9856 17.0213 22.0399 17.265 22.1435C17.5086 22.2471 17.7293 22.3981 17.9141 22.5877L21.5 26.1737L30.0859 17.5877C30.2707 17.3981 30.4914 17.2471 30.735 17.1435C30.9787 17.0399 31.2405 16.9856 31.5052 16.9839C31.77 16.9823 32.0325 17.0332 32.2774 17.1337C32.5224 17.2343 32.7449 17.3825 32.9321 17.5697C33.1194 17.7569 33.2675 17.9794 33.3681 18.2244C33.4686 18.4693 33.5196 18.7318 33.5179 18.9966C33.5162 19.2613 33.462 19.5231 33.3583 19.7668C33.2547 20.0104 33.1037 20.2311 32.9141 20.4159Z"
            fill="#304FFE"
          />
        </g>
        <defs>
          <clipPath id="clip0_1922_1571">
            <rect width="48" height="48" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const CardAssetBtc = () => {
  return (
    <>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="19.5"
          fill="white"
          stroke="#FEA513"
        />
        <path
          d="M20.1349 29.7163L18.4391 29.2935L19.1473 26.4529L17.7976 26.1164L17.0894 28.957L15.4019 28.5362L16.1181 25.6638L12.7168 24.8158L13.5585 22.8436L14.63 23.1107C14.7635 23.1484 14.902 23.1655 15.0407 23.1617C15.1412 23.1602 15.2392 23.1306 15.3237 23.0764C15.4054 23.016 15.4707 22.9363 15.5139 22.8444C15.5705 22.7265 15.6137 22.6027 15.6427 22.4751L17.4309 15.303C17.4583 15.1961 17.477 15.0872 17.4871 14.9774C17.4951 14.8887 17.4932 14.7995 17.4814 14.7113C17.4644 14.5685 17.4046 14.4342 17.3099 14.3259C17.0796 14.118 16.7939 13.9814 16.4875 13.9327L15.4922 13.6845L15.955 11.8281L19.3507 12.6748L20.0559 9.84665L21.753 10.2698L21.0627 13.0384L22.4083 13.3739L23.0986 10.6053L24.7971 11.0288L24.0913 13.8597C24.4285 13.9671 24.7592 14.0937 25.0819 14.239C25.361 14.3648 25.6308 14.5102 25.8894 14.6741C26.1142 14.8166 26.3263 14.9782 26.5233 15.1571C26.6971 15.3155 26.8543 15.4912 26.9925 15.6814C27.1183 15.8549 27.2241 16.042 27.3077 16.2393C27.3865 16.427 27.4431 16.6232 27.4766 16.824C27.5401 17.2305 27.5191 17.6457 27.4151 18.0438C27.2906 18.6835 26.9771 19.2712 26.5151 19.7309C26.3376 19.8936 26.1365 20.0283 25.9185 20.1306C25.7141 20.2241 25.5019 20.2996 25.2844 20.3562L25.3332 20.3846C25.5481 20.5063 25.7557 20.6405 25.9549 20.7866C26.076 20.8773 26.1916 20.9753 26.3007 21.0802C26.418 21.1958 26.5255 21.3209 26.6221 21.4543C26.7264 21.5945 26.816 21.7449 26.8895 21.9033C26.9688 22.0757 27.0277 22.2567 27.0653 22.4427C27.1076 22.6512 27.1256 22.8639 27.119 23.0765C27.1086 23.3284 27.0719 23.5784 27.0094 23.8226C26.9453 24.0826 26.8676 24.3391 26.7767 24.5909C26.6949 24.8182 26.598 25.0396 26.4864 25.2538C26.3847 25.4486 26.267 25.6347 26.1345 25.81C26.0097 25.9745 25.8693 26.1266 25.7154 26.2643C25.5645 26.3986 25.4005 26.5173 25.2257 26.6186C25.0463 26.7218 24.8575 26.8077 24.6618 26.875C24.4522 26.947 24.237 27.0015 24.0183 27.038C23.7776 27.0776 23.5345 27.101 23.2907 27.1081C23.0032 27.1172 22.7025 27.1084 22.3758 27.0917C22.1211 27.0752 21.8571 27.0491 21.5934 27.0157C21.1435 26.9565 20.8449 26.8923 20.8421 26.8916L20.1376 29.717L20.1349 29.7163ZM19.314 20.2351L18.3624 24.0516L19.7052 24.3864C20.3893 24.5627 21.0977 24.626 21.8022 24.574C22.1937 24.5818 22.5767 24.4593 22.891 24.2257C23.2053 23.9922 23.433 23.6608 23.5384 23.2836C23.7255 22.5333 23.3829 21.8789 22.5196 21.3372C21.8622 20.9542 21.1501 20.674 20.4079 20.5064L19.314 20.2351ZM20.5993 15.0799L19.7399 18.5268L20.9526 18.8292C21.2112 18.8932 21.4743 18.9382 21.7395 18.9636C22.0622 18.9985 22.3881 18.9918 22.7091 18.9437C23.0445 18.9171 23.3629 18.7848 23.6183 18.5657C23.8737 18.3467 24.0531 18.0522 24.1304 17.7248C24.2131 17.395 24.1813 17.0469 24.0401 16.7376C23.899 16.4283 23.6569 16.1761 23.3536 16.0225C23.0656 15.8395 22.7573 15.6906 22.4349 15.5787C22.1598 15.4811 21.8798 15.3975 21.596 15.3284L20.5993 15.0799Z"
          fill="#FEA513"
        />
      </svg>
    </>
  );
};

export const CardAssetEth = () => {
  return (
    <>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="19.5"
          fill="white"
          stroke="#8198EE"
        />
        <path
          d="M20.0373 7.78125L12.5488 20.0619L20.0373 24.5366L27.6215 20.0619L20.0373 7.78125Z"
          fill="white"
        />
        <path
          d="M12.6191 20.06L12.6283 20.0462L20.1279 16.75L21.7523 23.5661L20.108 24.5346L12.6191 20.06Z"
          fill="#C1CCF7"
        />
        <path
          d="M20.1221 7.79883L27.6983 20.0581L20.1221 24.5296V7.79883Z"
          fill="#C1CCF7"
        />
        <path
          d="M20.1517 32.0012V25.8716L12.6543 21.5195L20.1517 32.0012Z"
          fill="white"
        />
        <path
          d="M20.1436 32.0012V25.8716L27.641 21.5195L20.1436 32.0012Z"
          fill="#C1CCF7"
        />
        <path
          d="M20.1221 24.4978V16.9032L20.1588 16.75L27.6676 20.0462L27.6768 20.06L25.792 21.1848L20.1481 24.5132L20.1221 24.4978Z"
          fill="#8198EE"
        />
      </svg>
    </>
  );
};

export const HelpIcon = () => {
  return (
    <>
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2157_1433)">
          <path
            d="M21.3853 10.0268C21.2973 7.51802 20.2813 5.17202 18.4974 3.38808C16.6276 1.51789 14.1425 0.488281 11.5004 0.488281C6.16401 0.488281 1.80371 4.73573 1.61576 10.0268C0.801414 10.3887 0.231445 11.2038 0.231445 12.1511V14.7609C0.231445 16.0424 1.27399 17.0853 2.55588 17.0853C3.38532 17.0853 4.05987 16.4108 4.05987 15.5813V11.3303C4.05987 10.5515 3.46259 9.91648 2.70323 9.84102C2.98354 5.23131 6.82095 1.56641 11.5004 1.56641C13.855 1.56641 16.0691 2.48425 17.7355 4.15067C19.2657 5.68089 20.1613 7.67542 20.2961 9.84137C19.5374 9.91756 18.9412 10.5522 18.9412 11.3303V15.581C18.9412 16.3662 19.5478 17.0052 20.3162 17.0716V18.1458C20.3162 19.3555 19.3319 20.3394 18.1222 20.3394H16.4975C16.4177 20.1116 16.2926 19.901 16.1173 19.7263C15.81 19.4176 15.4003 19.2477 14.964 19.2477H13.2893C13.0489 19.2477 12.8182 19.2987 12.6069 19.3972C12.0304 19.662 11.6581 20.2435 11.6581 20.8785C11.6581 21.3148 11.8281 21.7245 12.1361 22.031C12.4441 22.3397 12.8538 22.5097 13.2893 22.5097H14.964C15.6583 22.5097 16.2704 22.0608 16.4986 21.4176H18.1222C19.9266 21.4176 21.3943 19.9499 21.3943 18.1458V16.8797C22.2036 16.5157 22.7693 15.7035 22.7693 14.7601V12.1504C22.7693 11.2038 22.1993 10.3887 21.3853 10.0268ZM2.98138 11.3303V15.581C2.98138 15.8156 2.79055 16.0068 2.55552 16.0068C1.8684 16.0068 1.30921 15.4476 1.30921 14.7605V12.1507C1.30921 11.4632 1.8684 10.9044 2.55552 10.9044C2.79055 10.9044 2.98138 11.0956 2.98138 11.3303ZM15.5049 20.9942C15.4513 21.2479 15.2235 21.4323 14.9637 21.4323H13.289C13.1416 21.4323 13.0033 21.3748 12.8976 21.2691C12.7934 21.1653 12.7359 21.0266 12.7359 20.8792C12.7359 20.664 12.862 20.4674 13.0597 20.3765C13.1301 20.3434 13.2074 20.3265 13.289 20.3265H14.9637C15.111 20.3265 15.2494 20.3836 15.3547 20.4893C15.4589 20.5932 15.5164 20.7319 15.5164 20.8792C15.5167 20.9188 15.5124 20.9583 15.5049 20.9942ZM21.6912 14.7605C21.6912 15.4476 21.132 16.0068 20.4449 16.0068C20.2102 16.0068 20.019 15.816 20.019 15.581V11.3303C20.019 11.0956 20.2098 10.9044 20.4449 10.9044C21.132 10.9044 21.6912 11.4636 21.6912 12.1507V14.7605Z"
            fill="#9EACDB"
          />
          <path
            d="M14.991 14.9453C16.2506 14.9453 17.2752 13.9204 17.2752 12.6611V8.00684C17.2752 7.39806 17.0373 6.8245 16.6053 6.39253C16.1733 5.96056 15.6001 5.72266 14.991 5.72266H8.00977C6.75016 5.72266 5.72559 6.74723 5.72559 8.00684V12.6611C5.72559 13.9207 6.75016 14.9453 8.00977 14.9453H8.05254V16.1514C8.05254 16.6114 8.32674 17.0196 8.75081 17.1917C8.88773 17.2467 9.03004 17.274 9.17091 17.274C9.46452 17.274 9.75059 17.1576 9.9601 16.9409L11.9665 14.9453H14.991ZM11.3645 14.0239L9.1932 16.1833C9.18349 16.1934 9.1763 16.201 9.15582 16.192C9.13102 16.1819 9.13102 16.1657 9.13102 16.1514V14.4062C9.13102 14.1087 8.88988 13.8672 8.59196 13.8672H8.01013C7.34493 13.8672 6.80407 13.326 6.80407 12.6611V8.00684C6.80407 7.34164 7.34493 6.80078 8.01013 6.80078H14.9914C15.3126 6.80078 15.6149 6.92656 15.8434 7.15477C16.072 7.38333 16.1974 7.68592 16.1974 8.00684V12.6611C16.1974 13.3263 15.6562 13.8672 14.9914 13.8672H11.7448C11.6021 13.8672 11.4655 13.9236 11.3645 14.0239Z"
            fill="#9EACDB"
          />
          <path
            d="M8.88123 9.625C8.4428 9.625 8.08594 9.98222 8.08594 10.4203C8.08594 10.8584 8.44316 11.2156 8.88123 11.2156C9.32003 11.2156 9.67725 10.8584 9.67725 10.4203C9.67725 9.98222 9.32039 9.625 8.88123 9.625Z"
            fill="#9EACDB"
          />
          <path
            d="M11.5004 9.625C11.0619 9.625 10.7051 9.98222 10.7051 10.4203C10.7051 10.8584 11.0623 11.2156 11.5004 11.2156C11.9395 11.2156 12.2964 10.8584 12.2964 10.4203C12.2964 9.98222 11.9395 9.625 11.5004 9.625Z"
            fill="#9EACDB"
          />
          <path
            d="M14.1185 9.625C13.6801 9.625 13.3232 9.98222 13.3232 10.4203C13.3232 10.8584 13.6805 11.2156 14.1185 11.2156C14.5573 11.2156 14.9146 10.8584 14.9146 10.4203C14.9146 9.98222 14.5573 9.625 14.1185 9.625Z"
            fill="#9EACDB"
          />
        </g>
        <defs>
          <clipPath id="clip0_2157_1433">
            <rect width="23" height="23" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const HelpActiveIcon = () => {
  return (
    <>
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2157_1433)">
          <path
            d="M21.3853 10.0268C21.2973 7.51802 20.2813 5.17202 18.4974 3.38808C16.6276 1.51789 14.1425 0.488281 11.5004 0.488281C6.16401 0.488281 1.80371 4.73573 1.61576 10.0268C0.801414 10.3887 0.231445 11.2038 0.231445 12.1511V14.7609C0.231445 16.0424 1.27399 17.0853 2.55588 17.0853C3.38532 17.0853 4.05987 16.4108 4.05987 15.5813V11.3303C4.05987 10.5515 3.46259 9.91648 2.70323 9.84102C2.98354 5.23131 6.82095 1.56641 11.5004 1.56641C13.855 1.56641 16.0691 2.48425 17.7355 4.15067C19.2657 5.68089 20.1613 7.67542 20.2961 9.84137C19.5374 9.91756 18.9412 10.5522 18.9412 11.3303V15.581C18.9412 16.3662 19.5478 17.0052 20.3162 17.0716V18.1458C20.3162 19.3555 19.3319 20.3394 18.1222 20.3394H16.4975C16.4177 20.1116 16.2926 19.901 16.1173 19.7263C15.81 19.4176 15.4003 19.2477 14.964 19.2477H13.2893C13.0489 19.2477 12.8182 19.2987 12.6069 19.3972C12.0304 19.662 11.6581 20.2435 11.6581 20.8785C11.6581 21.3148 11.8281 21.7245 12.1361 22.031C12.4441 22.3397 12.8538 22.5097 13.2893 22.5097H14.964C15.6583 22.5097 16.2704 22.0608 16.4986 21.4176H18.1222C19.9266 21.4176 21.3943 19.9499 21.3943 18.1458V16.8797C22.2036 16.5157 22.7693 15.7035 22.7693 14.7601V12.1504C22.7693 11.2038 22.1993 10.3887 21.3853 10.0268ZM2.98138 11.3303V15.581C2.98138 15.8156 2.79055 16.0068 2.55552 16.0068C1.8684 16.0068 1.30921 15.4476 1.30921 14.7605V12.1507C1.30921 11.4632 1.8684 10.9044 2.55552 10.9044C2.79055 10.9044 2.98138 11.0956 2.98138 11.3303ZM15.5049 20.9942C15.4513 21.2479 15.2235 21.4323 14.9637 21.4323H13.289C13.1416 21.4323 13.0033 21.3748 12.8976 21.2691C12.7934 21.1653 12.7359 21.0266 12.7359 20.8792C12.7359 20.664 12.862 20.4674 13.0597 20.3765C13.1301 20.3434 13.2074 20.3265 13.289 20.3265H14.9637C15.111 20.3265 15.2494 20.3836 15.3547 20.4893C15.4589 20.5932 15.5164 20.7319 15.5164 20.8792C15.5167 20.9188 15.5124 20.9583 15.5049 20.9942ZM21.6912 14.7605C21.6912 15.4476 21.132 16.0068 20.4449 16.0068C20.2102 16.0068 20.019 15.816 20.019 15.581V11.3303C20.019 11.0956 20.2098 10.9044 20.4449 10.9044C21.132 10.9044 21.6912 11.4636 21.6912 12.1507V14.7605Z"
            fill="#304FFE"
          />
          <path
            d="M14.991 14.9453C16.2506 14.9453 17.2752 13.9204 17.2752 12.6611V8.00684C17.2752 7.39806 17.0373 6.8245 16.6053 6.39253C16.1733 5.96056 15.6001 5.72266 14.991 5.72266H8.00977C6.75016 5.72266 5.72559 6.74723 5.72559 8.00684V12.6611C5.72559 13.9207 6.75016 14.9453 8.00977 14.9453H8.05254V16.1514C8.05254 16.6114 8.32674 17.0196 8.75081 17.1917C8.88773 17.2467 9.03004 17.274 9.17091 17.274C9.46452 17.274 9.75059 17.1576 9.9601 16.9409L11.9665 14.9453H14.991ZM11.3645 14.0239L9.1932 16.1833C9.18349 16.1934 9.1763 16.201 9.15582 16.192C9.13102 16.1819 9.13102 16.1657 9.13102 16.1514V14.4062C9.13102 14.1087 8.88988 13.8672 8.59196 13.8672H8.01013C7.34493 13.8672 6.80407 13.326 6.80407 12.6611V8.00684C6.80407 7.34164 7.34493 6.80078 8.01013 6.80078H14.9914C15.3126 6.80078 15.6149 6.92656 15.8434 7.15477C16.072 7.38333 16.1974 7.68592 16.1974 8.00684V12.6611C16.1974 13.3263 15.6562 13.8672 14.9914 13.8672H11.7448C11.6021 13.8672 11.4655 13.9236 11.3645 14.0239Z"
            fill="#304FFE"
          />
          <path
            d="M8.88123 9.625C8.4428 9.625 8.08594 9.98222 8.08594 10.4203C8.08594 10.8584 8.44316 11.2156 8.88123 11.2156C9.32003 11.2156 9.67725 10.8584 9.67725 10.4203C9.67725 9.98222 9.32039 9.625 8.88123 9.625Z"
            fill="#304FFE"
          />
          <path
            d="M11.5004 9.625C11.0619 9.625 10.7051 9.98222 10.7051 10.4203C10.7051 10.8584 11.0623 11.2156 11.5004 11.2156C11.9395 11.2156 12.2964 10.8584 12.2964 10.4203C12.2964 9.98222 11.9395 9.625 11.5004 9.625Z"
            fill="#304FFE"
          />
          <path
            d="M14.1185 9.625C13.6801 9.625 13.3232 9.98222 13.3232 10.4203C13.3232 10.8584 13.6805 11.2156 14.1185 11.2156C14.5573 11.2156 14.9146 10.8584 14.9146 10.4203C14.9146 9.98222 14.5573 9.625 14.1185 9.625Z"
            fill="#304FFE"
          />
        </g>
        <defs>
          <clipPath id="clip0_2157_1433">
            <rect width="23" height="23" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const SipActiveIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3115 3H8.66379V4H14.3115V3ZM15.9753 4H17C18.1046 4 19 4.89543 19 6V12.2561C19.356 12.3819 19.6915 12.5513 20 12.7578V6C20 4.34315 18.6569 3 17 3H15.9753V4ZM6 3H7V4H6C4.89543 4 4 4.89543 4 6V15C4 16.1046 4.89543 17 6 17H13.0275C13.0658 17.3467 13.1435 17.6816 13.2561 18H6C4.34315 18 3 16.6569 3 15V6C3 4.34315 4.34315 3 6 3Z"
        fill="#304FFE"
      />
      <rect
        x="14.25"
        y="2.25"
        width="1.5"
        height="2.5"
        rx="0.75"
        stroke="#304FFE"
        strokeWidth="0.5"
      />
      <rect
        x="7.25"
        y="2.25"
        width="1.5"
        height="2.5"
        rx="0.75"
        stroke="#304FFE"
        strokeWidth="0.5"
      />
      <circle cx="17.5" cy="16.5" r="4.5" stroke="#304FFE" />
      <line x1="3" y1="7.5" x2="20" y2="7.5" stroke="#304FFE" />
      <line
        x1="6.5"
        y1="10.5"
        x2="7.5"
        y2="10.5"
        stroke="#304FFE"
        strokeLinecap="round"
      />
      <line
        x1="6.5"
        y1="13.5"
        x2="7.5"
        y2="13.5"
        stroke="#304FFE"
        strokeLinecap="round"
      />
      <line
        x1="10.5"
        y1="10.5"
        x2="11.5"
        y2="10.5"
        stroke="#304FFE"
        strokeLinecap="round"
      />
      <line
        x1="10.5"
        y1="13.5"
        x2="11.5"
        y2="13.5"
        stroke="#304FFE"
        strokeLinecap="round"
      />
      <line
        x1="15.5"
        y1="10.5"
        x2="16.5"
        y2="10.5"
        stroke="#304FFE"
        strokeLinecap="round"
      />
      <path
        d="M18.895 17.0466C18.895 17.3095 18.7952 17.5325 18.5955 17.7155C18.3992 17.8985 18.113 18.005 17.737 18.0349V18.599H17.4175V18.0349C17.1746 18.0216 16.9434 17.9767 16.7237 17.9002C16.5075 17.8203 16.3344 17.7205 16.2046 17.6007L16.3893 17.2114C16.5091 17.3212 16.6605 17.4127 16.8435 17.4859C17.0266 17.5558 17.2179 17.5974 17.4175 17.6107V16.4527C17.1846 16.3961 16.99 16.3345 16.8336 16.268C16.6805 16.2014 16.5507 16.1033 16.4442 15.9735C16.3411 15.8437 16.2895 15.674 16.2895 15.4644C16.2895 15.2015 16.3843 14.9786 16.574 14.7955C16.767 14.6125 17.0482 14.506 17.4175 14.4761V13.9071H17.737V14.4711C17.9267 14.4778 18.1097 14.5077 18.286 14.5609C18.4657 14.6142 18.6205 14.6857 18.7502 14.7756L18.5855 15.1749C18.316 15.0052 18.0332 14.912 17.737 14.8954V16.0584C17.9799 16.1183 18.1796 16.1815 18.336 16.248C18.4924 16.3113 18.6238 16.4078 18.7303 16.5375C18.8401 16.664 18.895 16.8337 18.895 17.0466ZM16.7787 15.4444C16.7787 15.5875 16.8336 15.699 16.9434 15.7788C17.0532 15.8587 17.2112 15.9253 17.4175 15.9785V14.9004C17.2046 14.927 17.0449 14.9902 16.9384 15.09C16.8319 15.1865 16.7787 15.3047 16.7787 15.4444ZM17.737 17.6057C17.9599 17.5857 18.1263 17.5291 18.2361 17.436C18.3493 17.3395 18.4058 17.2197 18.4058 17.0766C18.4058 16.9302 18.3476 16.8187 18.2311 16.7422C18.118 16.6623 17.9533 16.5924 17.737 16.5325V17.6057Z"
        fill="#304FFE"
      />
    </svg>
  );
};

export const SipInactiveIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3115 3H8.66379V4H14.3115V3ZM15.9753 4H17C18.1046 4 19 4.89543 19 6V12.2561C19.356 12.3819 19.6915 12.5513 20 12.7578V6C20 4.34315 18.6569 3 17 3H15.9753V4ZM6 3H7V4H6C4.89543 4 4 4.89543 4 6V15C4 16.1046 4.89543 17 6 17H13.0275C13.0658 17.3467 13.1435 17.6816 13.2561 18H6C4.34315 18 3 16.6569 3 15V6C3 4.34315 4.34315 3 6 3Z"
        fill="#9EACDB"
      />
      <rect
        x="14.25"
        y="2.25"
        width="1.5"
        height="2.5"
        rx="0.75"
        stroke="#9EACDB"
        strokeWidth="0.5"
      />
      <rect
        x="7.25"
        y="2.25"
        width="1.5"
        height="2.5"
        rx="0.75"
        stroke="#9EACDB"
        strokeWidth="0.5"
      />
      <circle cx="17.5" cy="16.5" r="4.5" stroke="#9EACDB" />
      <line x1="3" y1="7.5" x2="20" y2="7.5" stroke="#9EACDB" />
      <line
        x1="6.5"
        y1="10.5"
        x2="7.5"
        y2="10.5"
        stroke="#9EACDB"
        strokeLinecap="round"
      />
      <line
        x1="6.5"
        y1="13.5"
        x2="7.5"
        y2="13.5"
        stroke="#9EACDB"
        strokeLinecap="round"
      />
      <line
        x1="10.5"
        y1="10.5"
        x2="11.5"
        y2="10.5"
        stroke="#9EACDB"
        strokeLinecap="round"
      />
      <line
        x1="10.5"
        y1="13.5"
        x2="11.5"
        y2="13.5"
        stroke="#9EACDB"
        strokeLinecap="round"
      />
      <line
        x1="15.5"
        y1="10.5"
        x2="16.5"
        y2="10.5"
        stroke="#9EACDB"
        strokeLinecap="round"
      />
      <path
        d="M18.895 17.0466C18.895 17.3095 18.7952 17.5325 18.5955 17.7155C18.3992 17.8985 18.113 18.005 17.737 18.0349V18.599H17.4175V18.0349C17.1746 18.0216 16.9434 17.9767 16.7237 17.9002C16.5075 17.8203 16.3344 17.7205 16.2046 17.6007L16.3893 17.2114C16.5091 17.3212 16.6605 17.4127 16.8435 17.4859C17.0266 17.5558 17.2179 17.5974 17.4175 17.6107V16.4527C17.1846 16.3961 16.99 16.3345 16.8336 16.268C16.6805 16.2014 16.5507 16.1033 16.4442 15.9735C16.3411 15.8437 16.2895 15.674 16.2895 15.4644C16.2895 15.2015 16.3843 14.9786 16.574 14.7955C16.767 14.6125 17.0482 14.506 17.4175 14.4761V13.9071H17.737V14.4711C17.9267 14.4778 18.1097 14.5077 18.286 14.5609C18.4657 14.6142 18.6205 14.6857 18.7502 14.7756L18.5855 15.1749C18.316 15.0052 18.0332 14.912 17.737 14.8954V16.0584C17.9799 16.1183 18.1796 16.1815 18.336 16.248C18.4924 16.3113 18.6238 16.4078 18.7303 16.5375C18.8401 16.664 18.895 16.8337 18.895 17.0466ZM16.7787 15.4444C16.7787 15.5875 16.8336 15.699 16.9434 15.7788C17.0532 15.8587 17.2112 15.9253 17.4175 15.9785V14.9004C17.2046 14.927 17.0449 14.9902 16.9384 15.09C16.8319 15.1865 16.7787 15.3047 16.7787 15.4444ZM17.737 17.6057C17.9599 17.5857 18.1263 17.5291 18.2361 17.436C18.3493 17.3395 18.4058 17.2197 18.4058 17.0766C18.4058 16.9302 18.3476 16.8187 18.2311 16.7422C18.118 16.6623 17.9533 16.5924 17.737 16.5325V17.6057Z"
        fill="#9EACDB"
      />
    </svg>
  );
};

export const DcaActiveIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 25"
    >
      <path
        d="M1.472 18.641v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M1.472 19.672v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M1.472 20.702v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M1.472 21.732v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M1.472 22.762v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M1.472 23.792v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368zM1.472 17.515v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M1.472 16.42v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M7.666 15.406c0 0.042 -0.031 0.119 -0.176 0.219 -0.14 0.096 -0.354 0.19 -0.633 0.271 -0.556 0.162 -1.335 0.264 -2.202 0.264s-1.646 -0.102 -2.202 -0.264c-0.279 -0.081 -0.493 -0.175 -0.633 -0.271 -0.145 -0.1 -0.176 -0.177 -0.176 -0.219 0 -0.042 0.031 -0.119 0.176 -0.219 0.14 -0.096 0.354 -0.19 0.633 -0.271 0.556 -0.162 1.335 -0.264 2.202 -0.264s1.646 0.102 2.202 0.264c0.279 0.081 0.493 0.175 0.633 0.271 0.145 0.1 0.176 0.177 0.176 0.219z"
        stroke="#304FFE"
        strokeWidth="0.341796875"
      />
      <path
        d="M9.152 16.581v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M9.152 17.611v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M9.152 18.641v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M9.152 19.672v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M9.152 20.702v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M9.152 21.732v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M9.152 22.762v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M9.152 23.792v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368zM9.152 15.454v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M9.152 14.36v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M15.346 13.346c0 0.042 -0.031 0.119 -0.176 0.219 -0.14 0.096 -0.354 0.19 -0.633 0.271 -0.556 0.162 -1.335 0.264 -2.202 0.264s-1.646 -0.102 -2.202 -0.264c-0.279 -0.081 -0.493 -0.175 -0.633 -0.271 -0.145 -0.1 -0.176 -0.177 -0.176 -0.219 0 -0.042 0.031 -0.119 0.176 -0.219 0.14 -0.096 0.354 -0.19 0.633 -0.271 0.556 -0.162 1.335 -0.264 2.202 -0.264s1.646 0.102 2.202 0.264c0.279 0.081 0.493 0.175 0.633 0.271 0.145 0.1 0.176 0.177 0.176 0.219z"
        stroke="#304FFE"
        strokeWidth="0.341796875"
      />
      <path
        d="M17.163 13.2v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.068 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M17.163 14.231v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M17.163 15.261v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M17.163 16.388v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M17.163 17.515v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M17.163 18.641v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M17.163 19.672v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M17.163 20.702v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M17.163 21.732v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M17.163 22.762v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M17.163 23.792v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368zM17.163 12.073v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M17.163 10.979v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#304FFE"
      />
      <path
        d="M23.357 9.965c0 0.042 -0.031 0.119 -0.176 0.219 -0.14 0.096 -0.354 0.19 -0.633 0.271 -0.556 0.162 -1.335 0.264 -2.202 0.264s-1.646 -0.102 -2.202 -0.264c-0.279 -0.081 -0.493 -0.175 -0.633 -0.271 -0.145 -0.1 -0.176 -0.177 -0.176 -0.219 0 -0.042 0.031 -0.119 0.176 -0.219 0.14 -0.096 0.354 -0.19 0.633 -0.271 0.556 -0.162 1.335 -0.264 2.202 -0.264 0.867 0 1.646 0.102 2.202 0.264 0.279 0.081 0.493 0.175 0.633 0.271 0.145 0.1 0.176 0.177 0.176 0.219z"
        stroke="#304FFE"
        strokeWidth="0.341796875"
      />
      <path
        d="M14.957 4.422C11.206 8.869 5.194 11.607 2.656 12.421c5.935 -1.334 11.511 -5.083 13.557 -6.791l0.411 1.16 2.054 -4.64 -4.736 1.861 1.015 0.411zM5.048 15.349c0.048 0.032 0.071 0.072 0.068 0.119 -0.003 0.047 -0.036 0.095 -0.099 0.145l0.103 0.069 -0.059 0.039 -0.103 -0.069a0.735 0.735 0 0 1 -0.152 0.069c-0.054 0.017 -0.105 0.026 -0.15 0.027l-0.037 -0.071c0.042 -0.001 0.087 -0.008 0.134 -0.022 0.047 -0.014 0.089 -0.032 0.129 -0.055l-0.212 -0.143c-0.053 0.022 -0.1 0.038 -0.141 0.049a0.389 0.389 0 0 1 -0.126 0.012c-0.043 -0.003 -0.083 -0.018 -0.122 -0.044 -0.048 -0.032 -0.072 -0.071 -0.07 -0.117 0.002 -0.046 0.034 -0.094 0.097 -0.143l-0.104 -0.07 0.059 -0.039 0.103 0.069c0.036 -0.022 0.075 -0.041 0.118 -0.056a0.566 0.566 0 0 1 0.125 -0.031l0.043 0.069c-0.081 0.012 -0.15 0.035 -0.208 0.07l0.213 0.143c0.056 -0.022 0.104 -0.039 0.145 -0.05a0.37 0.37 0 0 1 0.126 -0.013c0.043 0.002 0.085 0.016 0.124 0.043zm-0.683 0.062c0.026 0.018 0.057 0.025 0.092 0.021 0.035 -0.004 0.076 -0.015 0.124 -0.034l-0.198 -0.133c-0.034 0.029 -0.052 0.057 -0.053 0.082 -0.002 0.025 0.01 0.046 0.036 0.063zm0.573 0.149c0.037 -0.03 0.058 -0.057 0.061 -0.082 0.003 -0.026 -0.008 -0.047 -0.035 -0.065 -0.027 -0.018 -0.058 -0.025 -0.093 -0.02 -0.035 0.004 -0.079 0.016 -0.129 0.035l0.197 0.132zM12.728 13.279c0.048 0.032 0.071 0.072 0.068 0.119 -0.003 0.047 -0.036 0.095 -0.099 0.145l0.103 0.069 -0.059 0.039 -0.103 -0.069a0.737 0.737 0 0 1 -0.152 0.069c-0.054 0.017 -0.105 0.026 -0.15 0.027l-0.037 -0.071c0.042 -0.001 0.087 -0.008 0.134 -0.022a0.583 0.583 0 0 0 0.129 -0.055l-0.212 -0.143c-0.053 0.022 -0.1 0.038 -0.141 0.049a0.391 0.391 0 0 1 -0.126 0.012c-0.043 -0.003 -0.083 -0.018 -0.122 -0.044 -0.048 -0.032 -0.072 -0.071 -0.07 -0.117 0.002 -0.046 0.034 -0.094 0.097 -0.143l-0.104 -0.07 0.059 -0.039 0.103 0.069c0.036 -0.022 0.075 -0.041 0.118 -0.056 0.043 -0.015 0.084 -0.026 0.125 -0.031l0.043 0.069c-0.081 0.012 -0.15 0.035 -0.208 0.07l0.213 0.143c0.056 -0.022 0.104 -0.039 0.145 -0.05a0.367 0.367 0 0 1 0.126 -0.013c0.043 0.002 0.085 0.016 0.124 0.042zm-0.683 0.062c0.026 0.018 0.057 0.025 0.092 0.021 0.035 -0.004 0.076 -0.015 0.124 -0.034l-0.198 -0.133c-0.034 0.029 -0.052 0.057 -0.053 0.082 -0.002 0.025 0.01 0.046 0.036 0.063zm0.573 0.149c0.037 -0.03 0.058 -0.057 0.061 -0.082 0.003 -0.026 -0.008 -0.047 -0.035 -0.065 -0.027 -0.018 -0.058 -0.025 -0.094 -0.02 -0.035 0.004 -0.079 0.016 -0.129 0.035l0.197 0.132zM20.739 9.898c0.048 0.032 0.071 0.072 0.068 0.119 -0.003 0.047 -0.036 0.095 -0.1 0.145l0.103 0.069 -0.059 0.039 -0.103 -0.069a0.734 0.734 0 0 1 -0.152 0.069c-0.054 0.017 -0.105 0.026 -0.15 0.027l-0.037 -0.071c0.042 -0.001 0.087 -0.008 0.134 -0.022 0.047 -0.014 0.089 -0.032 0.129 -0.055l-0.212 -0.143c-0.053 0.022 -0.1 0.038 -0.141 0.049a0.389 0.389 0 0 1 -0.126 0.012c-0.043 -0.003 -0.083 -0.018 -0.122 -0.044 -0.048 -0.032 -0.072 -0.071 -0.07 -0.117 0.002 -0.046 0.034 -0.094 0.097 -0.143l-0.104 -0.07 0.059 -0.039 0.103 0.069c0.036 -0.022 0.075 -0.041 0.118 -0.056 0.043 -0.016 0.084 -0.026 0.125 -0.031l0.043 0.069c-0.081 0.012 -0.15 0.035 -0.207 0.07l0.213 0.143c0.056 -0.022 0.104 -0.039 0.145 -0.05a0.37 0.37 0 0 1 0.126 -0.013c0.043 0.002 0.085 0.016 0.124 0.043zm-0.683 0.062c0.026 0.018 0.057 0.025 0.092 0.021 0.035 -0.004 0.076 -0.015 0.124 -0.034l-0.198 -0.133c-0.034 0.029 -0.052 0.057 -0.053 0.082 -0.002 0.025 0.01 0.046 0.036 0.063zm0.573 0.149c0.037 -0.03 0.058 -0.057 0.061 -0.082 0.003 -0.026 -0.008 -0.047 -0.035 -0.065 -0.027 -0.018 -0.058 -0.025 -0.094 -0.02 -0.035 0.004 -0.079 0.016 -0.129 0.035l0.197 0.132z"
        fill="#304FFE"
      />
    </svg>
  );
};

export const DcaInactiveIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 25"
    >
      <path
        d="M1.472 18.641v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M1.472 19.672v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M1.472 20.702v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M1.472 21.732v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M1.472 22.762v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M1.472 23.792v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368zM1.472 17.515v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M1.472 16.42v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M7.666 15.406c0 0.042 -0.031 0.119 -0.176 0.219 -0.14 0.096 -0.354 0.19 -0.633 0.271 -0.556 0.162 -1.335 0.264 -2.202 0.264s-1.646 -0.102 -2.202 -0.264c-0.279 -0.081 -0.493 -0.175 -0.633 -0.271 -0.145 -0.1 -0.176 -0.177 -0.176 -0.219 0 -0.042 0.031 -0.119 0.176 -0.219 0.14 -0.096 0.354 -0.19 0.633 -0.271 0.556 -0.162 1.335 -0.264 2.202 -0.264s1.646 0.102 2.202 0.264c0.279 0.081 0.493 0.175 0.633 0.271 0.145 0.1 0.176 0.177 0.176 0.219z"
        stroke="#9EACDB"
        strokeWidth="0.341796875"
      />
      <path
        d="M9.152 16.581v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M9.152 17.611v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M9.152 18.641v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M9.152 19.672v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M9.152 20.702v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M9.152 21.732v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M9.152 22.762v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M9.152 23.792v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368zM9.152 15.454v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M9.152 14.36v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.689 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.12 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M15.346 13.346c0 0.042 -0.031 0.119 -0.176 0.219 -0.14 0.096 -0.354 0.19 -0.633 0.271 -0.556 0.162 -1.335 0.264 -2.202 0.264s-1.646 -0.102 -2.202 -0.264c-0.279 -0.081 -0.493 -0.175 -0.633 -0.271 -0.145 -0.1 -0.176 -0.177 -0.176 -0.219 0 -0.042 0.031 -0.119 0.176 -0.219 0.14 -0.096 0.354 -0.19 0.633 -0.271 0.556 -0.162 1.335 -0.264 2.202 -0.264s1.646 0.102 2.202 0.264c0.279 0.081 0.493 0.175 0.633 0.271 0.145 0.1 0.176 0.177 0.176 0.219z"
        stroke="#9EACDB"
        strokeWidth="0.341796875"
      />
      <path
        d="M17.163 13.2v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.068 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M17.163 14.231v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M17.163 15.261v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M17.163 16.388v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M17.163 17.515v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M17.163 18.641v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M17.163 19.672v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M17.163 20.702v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M17.163 21.732v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M17.163 22.762v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M17.163 23.792v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368zM17.163 12.073v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M17.163 10.979v-0.492c0.851 0.575 2.115 0.662 3.35 0.662 1.688 0 2.702 -0.441 3.015 -0.662v0.529c0 0.069 -0.011 0.138 -0.053 0.192 -0.26 0.341 -1.204 0.744 -2.936 0.744 -1.749 0 -2.675 -0.255 -3.195 -0.606 -0.121 -0.081 -0.181 -0.223 -0.181 -0.368z"
        fill="#9EACDB"
      />
      <path
        d="M23.357 9.965c0 0.042 -0.031 0.119 -0.176 0.219 -0.14 0.096 -0.354 0.19 -0.633 0.271 -0.556 0.162 -1.335 0.264 -2.202 0.264s-1.646 -0.102 -2.202 -0.264c-0.279 -0.081 -0.493 -0.175 -0.633 -0.271 -0.145 -0.1 -0.176 -0.177 -0.176 -0.219 0 -0.042 0.031 -0.119 0.176 -0.219 0.14 -0.096 0.354 -0.19 0.633 -0.271 0.556 -0.162 1.335 -0.264 2.202 -0.264 0.867 0 1.646 0.102 2.202 0.264 0.279 0.081 0.493 0.175 0.633 0.271 0.145 0.1 0.176 0.177 0.176 0.219z"
        stroke="#9EACDB"
        strokeWidth="0.341796875"
      />
      <path
        d="M14.957 4.422C11.206 8.869 5.194 11.607 2.656 12.421c5.935 -1.334 11.511 -5.083 13.557 -6.791l0.411 1.16 2.054 -4.64 -4.736 1.861 1.015 0.411zM5.048 15.349c0.048 0.032 0.071 0.072 0.068 0.119 -0.003 0.047 -0.036 0.095 -0.099 0.145l0.103 0.069 -0.059 0.039 -0.103 -0.069a0.735 0.735 0 0 1 -0.152 0.069c-0.054 0.017 -0.105 0.026 -0.15 0.027l-0.037 -0.071c0.042 -0.001 0.087 -0.008 0.134 -0.022 0.047 -0.014 0.089 -0.032 0.129 -0.055l-0.212 -0.143c-0.053 0.022 -0.1 0.038 -0.141 0.049a0.389 0.389 0 0 1 -0.126 0.012c-0.043 -0.003 -0.083 -0.018 -0.122 -0.044 -0.048 -0.032 -0.072 -0.071 -0.07 -0.117 0.002 -0.046 0.034 -0.094 0.097 -0.143l-0.104 -0.07 0.059 -0.039 0.103 0.069c0.036 -0.022 0.075 -0.041 0.118 -0.056a0.566 0.566 0 0 1 0.125 -0.031l0.043 0.069c-0.081 0.012 -0.15 0.035 -0.208 0.07l0.213 0.143c0.056 -0.022 0.104 -0.039 0.145 -0.05a0.37 0.37 0 0 1 0.126 -0.013c0.043 0.002 0.085 0.016 0.124 0.043zm-0.683 0.062c0.026 0.018 0.057 0.025 0.092 0.021 0.035 -0.004 0.076 -0.015 0.124 -0.034l-0.198 -0.133c-0.034 0.029 -0.052 0.057 -0.053 0.082 -0.002 0.025 0.01 0.046 0.036 0.063zm0.573 0.149c0.037 -0.03 0.058 -0.057 0.061 -0.082 0.003 -0.026 -0.008 -0.047 -0.035 -0.065 -0.027 -0.018 -0.058 -0.025 -0.093 -0.02 -0.035 0.004 -0.079 0.016 -0.129 0.035l0.197 0.132zM12.728 13.279c0.048 0.032 0.071 0.072 0.068 0.119 -0.003 0.047 -0.036 0.095 -0.099 0.145l0.103 0.069 -0.059 0.039 -0.103 -0.069a0.737 0.737 0 0 1 -0.152 0.069c-0.054 0.017 -0.105 0.026 -0.15 0.027l-0.037 -0.071c0.042 -0.001 0.087 -0.008 0.134 -0.022a0.583 0.583 0 0 0 0.129 -0.055l-0.212 -0.143c-0.053 0.022 -0.1 0.038 -0.141 0.049a0.391 0.391 0 0 1 -0.126 0.012c-0.043 -0.003 -0.083 -0.018 -0.122 -0.044 -0.048 -0.032 -0.072 -0.071 -0.07 -0.117 0.002 -0.046 0.034 -0.094 0.097 -0.143l-0.104 -0.07 0.059 -0.039 0.103 0.069c0.036 -0.022 0.075 -0.041 0.118 -0.056 0.043 -0.015 0.084 -0.026 0.125 -0.031l0.043 0.069c-0.081 0.012 -0.15 0.035 -0.208 0.07l0.213 0.143c0.056 -0.022 0.104 -0.039 0.145 -0.05a0.367 0.367 0 0 1 0.126 -0.013c0.043 0.002 0.085 0.016 0.124 0.042zm-0.683 0.062c0.026 0.018 0.057 0.025 0.092 0.021 0.035 -0.004 0.076 -0.015 0.124 -0.034l-0.198 -0.133c-0.034 0.029 -0.052 0.057 -0.053 0.082 -0.002 0.025 0.01 0.046 0.036 0.063zm0.573 0.149c0.037 -0.03 0.058 -0.057 0.061 -0.082 0.003 -0.026 -0.008 -0.047 -0.035 -0.065 -0.027 -0.018 -0.058 -0.025 -0.094 -0.02 -0.035 0.004 -0.079 0.016 -0.129 0.035l0.197 0.132zM20.739 9.898c0.048 0.032 0.071 0.072 0.068 0.119 -0.003 0.047 -0.036 0.095 -0.1 0.145l0.103 0.069 -0.059 0.039 -0.103 -0.069a0.734 0.734 0 0 1 -0.152 0.069c-0.054 0.017 -0.105 0.026 -0.15 0.027l-0.037 -0.071c0.042 -0.001 0.087 -0.008 0.134 -0.022 0.047 -0.014 0.089 -0.032 0.129 -0.055l-0.212 -0.143c-0.053 0.022 -0.1 0.038 -0.141 0.049a0.389 0.389 0 0 1 -0.126 0.012c-0.043 -0.003 -0.083 -0.018 -0.122 -0.044 -0.048 -0.032 -0.072 -0.071 -0.07 -0.117 0.002 -0.046 0.034 -0.094 0.097 -0.143l-0.104 -0.07 0.059 -0.039 0.103 0.069c0.036 -0.022 0.075 -0.041 0.118 -0.056 0.043 -0.016 0.084 -0.026 0.125 -0.031l0.043 0.069c-0.081 0.012 -0.15 0.035 -0.207 0.07l0.213 0.143c0.056 -0.022 0.104 -0.039 0.145 -0.05a0.37 0.37 0 0 1 0.126 -0.013c0.043 0.002 0.085 0.016 0.124 0.043zm-0.683 0.062c0.026 0.018 0.057 0.025 0.092 0.021 0.035 -0.004 0.076 -0.015 0.124 -0.034l-0.198 -0.133c-0.034 0.029 -0.052 0.057 -0.053 0.082 -0.002 0.025 0.01 0.046 0.036 0.063zm0.573 0.149c0.037 -0.03 0.058 -0.057 0.061 -0.082 0.003 -0.026 -0.008 -0.047 -0.035 -0.065 -0.027 -0.018 -0.058 -0.025 -0.094 -0.02 -0.035 0.004 -0.079 0.016 -0.129 0.035l0.197 0.132z"
        fill="#9EACDB"
      />
    </svg>
  );
};

export const ReferActiveIcon = () => {
  return (
    <svg
      width="25"
      height="24.922"
      viewBox="0 0 25 24.922"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.032 15.046c-1.026 -0.051 -1.23 0.821 -1.204 1.263 0.284 -0.754 0.921 -0.8 1.204 -0.729v0.142l0.463 -0.441 -0.463 -0.4v0.164Z"
        stroke="#304FFE"
        strokeWidth="0.0778816199376947"
        strokeLinejoin="round"
      />
      <path
        d="M10.501 15.046c1.026 -0.051 1.23 0.821 1.204 1.263 -0.284 -0.754 -0.921 -0.8 -1.204 -0.729v0.142l-0.464 -0.441 0.464 -0.4v0.164Z"
        stroke="#304FFE"
        strokeWidth="0.0778816199376947"
        strokeLinejoin="round"
      />
      <path
        cx="209.264"
        cy="294.915"
        r="36.3155"
        stroke="#304FFE"
        strokeWidth="0.46728971962616817"
        d="M9.563 11.484A1.414 1.414 0 0 1 8.149 12.898A1.414 1.414 0 0 1 6.735 11.484A1.414 1.414 0 0 1 9.563 11.484z"
      />
      <path
        cx="302.162"
        cy="274.999"
        r="36.3155"
        stroke="#304FFE"
        strokeWidth="0.46728971962616817"
        d="M13.181 10.709A1.414 1.414 0 0 1 11.766 12.123A1.414 1.414 0 0 1 10.352 10.709A1.414 1.414 0 0 1 13.181 10.709z"
      />
      <path
        cx="395.061"
        cy="294.915"
        r="30.6566"
        stroke="#304FFE"
        strokeWidth="0.46728971962616817"
        d="M16.578 11.484A1.194 1.194 0 0 1 15.384 12.678A1.194 1.194 0 0 1 14.19 11.484A1.194 1.194 0 0 1 16.578 11.484z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.271 5.543c-1.069 -0.483 -2.256 -0.752 -3.505 -0.752 -4.708 0 -8.524 3.816 -8.524 8.524 0 4.708 3.816 8.524 8.524 8.524 4.708 0 8.524 -3.816 8.524 -8.524 0 -1.369 -0.323 -2.662 -0.896 -3.808a3.005 3.005 0 0 1 -0.74 0.263c0.548 1.062 0.857 2.268 0.857 3.546 0 4.278 -3.468 7.745 -7.745 7.745 -4.278 0 -7.745 -3.468 -7.745 -7.745s3.468 -7.745 7.745 -7.745c1.169 0 2.278 0.259 3.272 0.723a3.006 3.006 0 0 1 0.233 -0.75Z"
        fill="#304FFE"
      />
      <path
        cx="462.782"
        cy="174.876"
        r="70.7229"
        stroke="#304FFE"
        strokeWidth="0.5451713395638629"
        d="M20.775 6.81A2.754 2.754 0 0 1 18.021 9.564A2.754 2.754 0 0 1 15.267 6.81A2.754 2.754 0 0 1 20.775 6.81z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.201 16.258h-3.022v-0.309c0 -1.088 0.882 -1.97 1.97 -1.97 0.592 0 1.122 0.261 1.483 0.674a2.579 2.579 0 0 1 0.298 -0.367c-0.445 -0.476 -1.078 -0.774 -1.781 -0.774 -1.346 0 -2.437 1.091 -2.437 2.437v0.776h3.489v-0.467Z"
        fill="#304FFE"
      />
      <path
        d="M14.268 16.132v0.638H9.264v-0.638c0 -1.382 1.12 -2.502 2.502 -2.502 1.382 0 2.502 1.12 2.502 2.502Z"
        stroke="#304FFE"
        strokeWidth="0.46728971962616817"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.408 16.726h3.613v-0.776c0 -1.346 -1.091 -2.437 -2.437 -2.437 -0.734 0 -1.392 0.325 -1.839 0.838a2.648 2.648 0 0 1 0.285 0.388c0.361 -0.462 0.923 -0.759 1.554 -0.759 1.088 0 1.97 0.882 1.97 1.97v0.309h-3.146v0.467Z"
        fill="#304FFE"
      />
      <path
        d="M19.25 7.455c0 0.214 -0.081 0.395 -0.244 0.544 -0.16 0.149 -0.393 0.236 -0.7 0.26v0.459h-0.26v-0.459c-0.198 -0.011 -0.386 -0.047 -0.565 -0.11 -0.176 -0.065 -0.317 -0.146 -0.423 -0.244l0.151 -0.317c0.098 0.089 0.221 0.164 0.37 0.223a1.604 1.604 0 0 0 0.468 0.102v-0.942c-0.19 -0.046 -0.348 -0.096 -0.476 -0.15a0.836 0.836 0 0 1 -0.317 -0.24c-0.084 -0.106 -0.126 -0.244 -0.126 -0.414 0 -0.214 0.077 -0.395 0.232 -0.544 0.157 -0.149 0.386 -0.236 0.687 -0.26v-0.463h0.26v0.459c0.155 0.005 0.304 0.03 0.447 0.073 0.146 0.043 0.273 0.102 0.378 0.175l-0.134 0.325c-0.22 -0.138 -0.45 -0.214 -0.691 -0.227v0.946c0.198 0.049 0.361 0.1 0.488 0.154 0.127 0.051 0.235 0.13 0.321 0.236 0.089 0.103 0.134 0.241 0.134 0.414Zm-1.724 -1.303c0 0.116 0.045 0.207 0.134 0.272 0.089 0.065 0.218 0.119 0.386 0.162v-0.877c-0.173 0.022 -0.304 0.073 -0.39 0.154 -0.087 0.079 -0.13 0.175 -0.13 0.288Zm0.781 1.758c0.182 -0.016 0.317 -0.062 0.407 -0.138 0.092 -0.079 0.138 -0.176 0.138 -0.292 0 -0.119 -0.047 -0.21 -0.142 -0.272 -0.092 -0.065 -0.226 -0.122 -0.403 -0.171v0.873Z"
        fill="#304FFE"
      />
    </svg>
  );
};

export const ReferInactiveIcon = () => {
  return (
    <svg
      width="25"
      height="24.922"
      viewBox="0 0 25 24.922"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.032 15.046c-1.026 -0.051 -1.23 0.821 -1.204 1.263 0.284 -0.754 0.921 -0.8 1.204 -0.729v0.142l0.463 -0.441 -0.463 -0.4v0.164Z"
        stroke="#9EACDB"
        strokeWidth="0.0778816199376947"
        strokeLinejoin="round"
      />
      <path
        d="M10.501 15.046c1.026 -0.051 1.23 0.821 1.204 1.263 -0.284 -0.754 -0.921 -0.8 -1.204 -0.729v0.142l-0.464 -0.441 0.464 -0.4v0.164Z"
        stroke="#9EACDB"
        strokeWidth="0.0778816199376947"
        strokeLinejoin="round"
      />
      <path
        cx="209.264"
        cy="294.915"
        r="36.3155"
        stroke="#9EACDB"
        strokeWidth="0.46728971962616817"
        d="M9.563 11.484A1.414 1.414 0 0 1 8.149 12.898A1.414 1.414 0 0 1 6.735 11.484A1.414 1.414 0 0 1 9.563 11.484z"
      />
      <path
        cx="302.162"
        cy="274.999"
        r="36.3155"
        stroke="#9EACDB"
        strokeWidth="0.46728971962616817"
        d="M13.181 10.709A1.414 1.414 0 0 1 11.766 12.123A1.414 1.414 0 0 1 10.352 10.709A1.414 1.414 0 0 1 13.181 10.709z"
      />
      <path
        cx="395.061"
        cy="294.915"
        r="30.6566"
        stroke="#9EACDB"
        strokeWidth="0.46728971962616817"
        d="M16.578 11.484A1.194 1.194 0 0 1 15.384 12.678A1.194 1.194 0 0 1 14.19 11.484A1.194 1.194 0 0 1 16.578 11.484z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.271 5.543c-1.069 -0.483 -2.256 -0.752 -3.505 -0.752 -4.708 0 -8.524 3.816 -8.524 8.524 0 4.708 3.816 8.524 8.524 8.524 4.708 0 8.524 -3.816 8.524 -8.524 0 -1.369 -0.323 -2.662 -0.896 -3.808a3.005 3.005 0 0 1 -0.74 0.263c0.548 1.062 0.857 2.268 0.857 3.546 0 4.278 -3.468 7.745 -7.745 7.745 -4.278 0 -7.745 -3.468 -7.745 -7.745s3.468 -7.745 7.745 -7.745c1.169 0 2.278 0.259 3.272 0.723a3.006 3.006 0 0 1 0.233 -0.75Z"
        fill="#9EACDB"
      />
      <path
        cx="462.782"
        cy="174.876"
        r="70.7229"
        stroke="#9EACDB"
        strokeWidth="0.5451713395638629"
        d="M20.775 6.81A2.754 2.754 0 0 1 18.021 9.564A2.754 2.754 0 0 1 15.267 6.81A2.754 2.754 0 0 1 20.775 6.81z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.201 16.258h-3.022v-0.309c0 -1.088 0.882 -1.97 1.97 -1.97 0.592 0 1.122 0.261 1.483 0.674a2.579 2.579 0 0 1 0.298 -0.367c-0.445 -0.476 -1.078 -0.774 -1.781 -0.774 -1.346 0 -2.437 1.091 -2.437 2.437v0.776h3.489v-0.467Z"
        fill="#9EACDB"
      />
      <path
        d="M14.268 16.132v0.638H9.264v-0.638c0 -1.382 1.12 -2.502 2.502 -2.502 1.382 0 2.502 1.12 2.502 2.502Z"
        stroke="#9EACDB"
        strokeWidth="0.46728971962616817"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.408 16.726h3.613v-0.776c0 -1.346 -1.091 -2.437 -2.437 -2.437 -0.734 0 -1.392 0.325 -1.839 0.838a2.648 2.648 0 0 1 0.285 0.388c0.361 -0.462 0.923 -0.759 1.554 -0.759 1.088 0 1.97 0.882 1.97 1.97v0.309h-3.146v0.467Z"
        fill="#9EACDB"
      />
      <path
        d="M19.25 7.455c0 0.214 -0.081 0.395 -0.244 0.544 -0.16 0.149 -0.393 0.236 -0.7 0.26v0.459h-0.26v-0.459c-0.198 -0.011 -0.386 -0.047 -0.565 -0.11 -0.176 -0.065 -0.317 -0.146 -0.423 -0.244l0.151 -0.317c0.098 0.089 0.221 0.164 0.37 0.223a1.604 1.604 0 0 0 0.468 0.102v-0.942c-0.19 -0.046 -0.348 -0.096 -0.476 -0.15a0.836 0.836 0 0 1 -0.317 -0.24c-0.084 -0.106 -0.126 -0.244 -0.126 -0.414 0 -0.214 0.077 -0.395 0.232 -0.544 0.157 -0.149 0.386 -0.236 0.687 -0.26v-0.463h0.26v0.459c0.155 0.005 0.304 0.03 0.447 0.073 0.146 0.043 0.273 0.102 0.378 0.175l-0.134 0.325c-0.22 -0.138 -0.45 -0.214 -0.691 -0.227v0.946c0.198 0.049 0.361 0.1 0.488 0.154 0.127 0.051 0.235 0.13 0.321 0.236 0.089 0.103 0.134 0.241 0.134 0.414Zm-1.724 -1.303c0 0.116 0.045 0.207 0.134 0.272 0.089 0.065 0.218 0.119 0.386 0.162v-0.877c-0.173 0.022 -0.304 0.073 -0.39 0.154 -0.087 0.079 -0.13 0.175 -0.13 0.288Zm0.781 1.758c0.182 -0.016 0.317 -0.062 0.407 -0.138 0.092 -0.079 0.138 -0.176 0.138 -0.292 0 -0.119 -0.047 -0.21 -0.142 -0.272 -0.092 -0.065 -0.226 -0.122 -0.403 -0.171v0.873Z"
        fill="#9EACDB"
      />
    </svg>
  );
};
